import React, {
  useState,
  useRef,
  useEffect,
  useImperativeHandle,
  forwardRef,
} from "react";
import {
  ChakraProvider,
  Box,
  Button,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  Flex,
  AccordionIcon,
  Badge,
  Stack,
  RadioGroup,
  Image,
  InputGroup,
  Radio,
  CheckboxGroup,
  Heading,
  Text,
  Checkbox,
  Spacer,
  Divider,
  Textarea,
  Input,
} from "@chakra-ui/react";

import ModalRight from "../../../components/modal-right";

import DatePicker from "../../../components/date-picker";
import {
  PrimaryButton,
  Toaster,
  PrimaryInput,
  SearchBar,
  DropdownInput,
} from "../../../components";

import { format } from "date-fns";

import {
  updateDoctorNotes,
  GetDoctorNotes,
  GetDoctorMasterData,
  GetDoctorFavMedicine,
  GetAIMedicineComposition,
  createAppointmentDieticianNotes,
  deleteAppointmentDieticianNotes,
  createGeneralAppointmentDieticianNotes,
  deleteGeneralAppointmentDieticianNotes,
} from "../../../middleware/services/visits/patient-overview/updatedoctornotes";
import CurrentOrderView from "./order-details";
import CurrentOrderMedications from "./order-medication-details";
import PrescriptionComponent from "./order-prescription";
import moment from "moment";
import { COLORS } from "../../styles/colors";
import DynamicModal from "../../dynamic-modal";
import useLoader from "../../loader/loaderstates";
import Loader from "../../loader/loader";
import {
  AiRecommendMedicines,
  CorrectChiefComplaintUsingAI,
  CorrectMedicalTermsUsingAI,
  FetchMedicineAIAnswer,
  FetchMedicineAIPrompts,
  FetchMyHealthAIData,
  RecommendDieticianNotesUsingAI,
} from "../../../middleware/services/visits/aicalls";
import MiniDropdownInput from "../../mini-dropdown";
import TypingLoader from "../../typing-loader";
import AiModal from "../../ai-modal";
import DynamicModalForTwo from "./dynamic-modal-for-two";
import AICPUFeedbackFooter from "./ai-feedback/cpu-feedback";
import AIFeedbackFooter from "./ai-feedback";
import { actionAccessMain, getLoginID, getPatientId, validationOfNumberWithOnly1Decimal } from "../../../auth";
import PatientVisitNav from "../../patient-visit-navbar";
import { GetPatientHealthData } from "../../../middleware/services/visits/patient-overview";
import { addVaccination, getVaccineList } from "../../../middleware/services/messages";
import DatePickerQuick from "../date-picker-quick";
import { GPUChatAudioManager } from "./cheif-complaint-audio/gpuChatVoiceManager";
import { useForm } from "react-hook-form";
import { useGPUTranscriber } from "./cheif-complaint-audio/useGPUTranscriber";

const DoctorNotesOrders = forwardRef(
  (
    {
      patientId,
      patientname,
      patientgender,
      patientage,
      doctorId,
      appointmentId,
      showSuccessToast,
      showErrorToast,
      showSubLoader,
      dismissSubLoader,
      searchRef,
      triggerFetchRecommendMedicines,
      fetchDoctorNotesEmptyIndication,
      fetchPatientHealthData,
      fetchedDoctorSpeciality,
      fetchedDoctorExperience
    },
    ref
  ) => {
    useEffect(() => {
      if (triggerFetchRecommendMedicines) {
        fetchRecommendMedicines();
      }
    }, [triggerFetchRecommendMedicines]);

    const useGPUChatbot = !!navigator.gpu;
    // const useGPUChatbot = false;

    const [doctorNotes, setDoctorNotes] = useState({});
    const [recommendMedicinesAiResponse, setRecommendMedicinesAiResponse] =
      useState([]);
    const [recommendProceduresAiResponse, setRecommendProceduresAiResponse] =
      useState([]);
    const [recommendLabsAiResponse, setRecommendLabsAiResponse] = useState([]);
    const [recommendImagingAiResponse, setRecommendImagingAiResponse] =
      useState([]);

    const [combinedOrderAIResponses, setCombinedOrderAIResponses] =
      useState(null);

    const [
      selectedRecommendedMedicinesAiResponses,
      setSelectedRecommendedMedicinesAiResponses,
    ] = useState([]);

    const [selectedOrderAiResponses, setSelectedOrderAiResponses] = useState(
      []
    );

    const [inputProceduresMasterData, setInputProceduresMasterData] = useState(
      []
    );
    const [inputVaccinesMasterData, setInputVaccinesMasterData] = useState(
      []
    );
    const [inputLabsMasterData, setInputLabsMasterData] = useState([]);
    const [inputImagingMasterData, setInputImagingMasterData] = useState([]);
    const [inputDoctorFavMedicineData, setInputDoctorFavMedicineData] =
      useState([]);
    const [addAppointmentDieticianNotes, setAddAppointmentDieticianNotes] = useState();
    const [dieticianNotes, setDieticianNotes] = useState([]);
    const [deleteDieticianId, setDeleteDieticianId] = useState(null);
    const [updateDieticianNotes, setUpdateDieticianNotes] = useState(null);

    const [addGeneralAppointmentDieticianNotes, setAddGeneralAppointmentDieticianNotes] = useState("");
    const [generalDieticianNotes, setGeneralDieticianNotes] = useState([]);
    const [deleteGeneralDieticianId, setGeneralDeleteDieticianId] = useState(null);
    const [updateGeneralDieticianNotes, setUpdateGeneralDieticianNotes] = useState(null);

    const noAiResponseModal = useRef();
    const aiRecommendMedicineRef = useRef();
    const deleteDieticianNotesModal = useRef();
    const editDieticianNotesModal = useRef();

    const deleteGeneralDieticianNotesModal = useRef();
    const editGeneralDieticianNotesModal = useRef();

    const dieticianNotesRef = useRef(null);
    const generalNotesRef = useRef(null);


    // Define state to store formatted input data - FOR PATIENT CURRENT VISIT
      const [patientHealthData, setPatientHealthData] = useState(null);
      const [patientFullInfo, setPatientFullInfo] = useState(null);
      const [navHeaderOverviewData, setNavHeaderOverviewData] = useState(null);
    
      // Define state to store input data - FOR PATIENT CURRENT VISIT
      const [inputData, setInputData] = useState({
        patientid: patientId,
        // appointmentid: appointmentId,
        doctorid: doctorId,
      });
      const [patientCountryId, setPatientCountryId] = useState(null);
    
      // Function to fetch patient entire health data and update state - FOR PATIENT CURRENT VISIT
      const fetchPatientHealthNavData = async () => {
        showLoader();
        try {
          const data = await GetPatientHealthData(inputData);
          // console.log(data, 'check data for Nav');
          if(data && data.patientinfo && data.patientinfo.countryid) {
            setPatientCountryId(data.patientinfo.countryid)
          }
          // console.log(data.patientinfo.countryid, "counrtyr id")
          setPatientHealthData(data);
          // console.log(data.patientinfo, "data.patientinfo")
          setPatientFullInfo(data.patientinfo)
        } catch (error) {
          console.error("Error fetching patient health data:", error);
        } finally {
          dismissLoader();
        }
      };
    
      /// Call fetchPatientHealthData function whenever inputData or formattedInput changes
      useEffect(() => {
        fetchPatientHealthNavData();
      }, []);
      // }, [inputData]);
    
      function calculateAge(dob) {
        if (!dob) {
          return "";
        }
    
        const dobDate = new Date(dob);
        const today = new Date();
    
        let age = today.getFullYear() - dobDate.getFullYear();
        const monthDifference = today.getMonth() - dobDate.getMonth();
        const dayDifference = today.getDate() - dobDate.getDate();
    
        if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
          age--;
        }
    
        return age;
      }
    
      function formatHeightNumber(input) {
        const parts = input.toString().split(".");
        return {
          height: parts[0], // Whole number (integer part)
          subHeight: parts[1]?.padEnd(2, "0") || "0", // Decimal part (padded to 2 digits)
        };
      }
    
      useEffect(() => {
        if (patientHealthData) {
          const {
            // firstname,
            // lastname,
            // patientimage,
            // imagepath,
            uniqueid,
            gender,
            dob,
            bloodtype,
            countrycode,
            mobileno,
            height,
            heightunit,
            weight,
            weightunit,
            bmi,
          } = patientHealthData.patientinfo;
    
          // const patientFullName = firstname + lastname
          // const patientImage = patientimage ? imagepath + patientimage : ''
          const uniqueId = "#" + uniqueid
          const formattedGender = gender
            ? gender.charAt(0).toUpperCase() + gender.slice(1)
            : null;
          const dobInYears = dob ? calculateAge(dob) : null;
          const formattedBloodType = bloodtype || null;
          const formattedCountryCode = countrycode || null;
          const formattedMobileNo = mobileno || null;
          const formattedHeight =
            height && heightunit ? `${height} ${heightunit}` : null;
          const formattedWeight =
            weight && weightunit ? `${weight} ${weightunit}` : null;
          const formattedBMI = bmi || null;
    
          const overviewData = [
            // patientFullName,
            // patientImage,
            uniqueId,
            formattedGender,
            dobInYears ? `${dobInYears} years` : null,
            formattedBloodType,
            formattedCountryCode && formattedMobileNo
              ? `(${formattedCountryCode}) ${formattedMobileNo}`
              : null,
            formattedHeight,
            formattedWeight,
            formattedBMI ? `${formattedBMI} BMI` : null,
          ]
            .filter((item) => item !== null)
            .join(", ");
    
          setNavHeaderOverviewData(overviewData);
        }
      }, [patientHealthData]);


    useEffect(() => {
      // Create an async function to fetch data
      const fetchData = async () => {
        try {
          const labsData = await fetchMasterData("labs");
          const imagingData = await fetchMasterData("imaging");
          const proceduresData = await fetchMasterData("procedures");
          const vaccinesData = await fetchMasterData("vaccine");

          // Update state with fetched data
          setInputLabsMasterData(labsData);
          setInputImagingMasterData(imagingData);
          setInputProceduresMasterData(proceduresData);
          setInputVaccinesMasterData(vaccinesData);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };

      fetchData(); // Call the async function
    }, []); // Empty dependency array to ensure it runs only once on mount

    useEffect(() => {
      // Create an async function to fetch data

      const fetchDoctorMedicines = async () => {
        // console.log("Function called");
        const inputToFetch = {
          input: {
            doctorid: doctorId,
          },
        };
        // showLoader();
        // console.log(inputToFetch);
        try {
          const data = await GetDoctorFavMedicine(inputToFetch.input);
          setInputDoctorFavMedicineData(data?.output?.data);
          // console.log(data);
        } catch (error) {
          console.error("Error fetching Recent Medications data:", error);
        } finally {
          // dismissLoader();
        }
      };
      fetchDoctorMedicines();
    }, []); // Empty dependency array to ensure it runs only once on mount

    //------------AI Medicine Recommendations

    const [editMedicine, setEditMedicine] = useState(null);

    const today = moment().format("DD-MM-YYYY");
    const fiveDaysFromToday = moment().add(5, "days").format("DD-MM-YYYY");
    const handleEditMedicine = (medicine) => {
      // const medicinetoedit = {
      //   id: medicine.id,
      //   medicinename: medicine.name,
      //   composition: medicine.composition,
      //   medicinetype: "Tablet",
      //   dosage: "",
      //   dosageunit: "mg",
      //   medicationstartdate: today, // SETTING DEFAULTS
      //   medicationenddate: fiveDaysFromToday, // SETTING DEFAULTS
      //   frequency: 1, // SETTING DEFAULTS
      //   morning: 1, // SETTING DEFAULTS
      //   evening: 0,
      //   night: 0,
      //   prescribedby: "",
      //   hospitalname: "",
      //   beforefood: 1, // SETTING DEFAULTS
      //   afterfood: 0,
      //   // issaved: false,
      // };
      setEditMedicine(medicine);
    };

    const handleEditMedicineChange = (field, value) => {
      setEditMedicine((prev) => ({ ...prev, [field]: value }));
    };

    const handleSaveEditMedicine = () => {
      if (editMedicine.medicinename === "") {
        showErrorToast("Please enter medicine name to continue");
        return;
      }
      setRecommendMedicinesAiResponse((prev) =>
        prev.map((m) => (m.id === editMedicine.id ? editMedicine : m))
      );

      // console.log(selectedMedicines);
      setEditMedicine(null);
    };

    const [compositionEditKey, setCompositionEditKey] = useState(0); // to rerender the composition input box

    const fetchCompositionForEdit = async (medicineName) => {
      if (!medicineName) {
        showErrorToast("Please enter medicine name first to fetch composition");
      } else {
        const inputData = {
          input: {
            name: medicineName,
          },
        };

        // console.log(inputData.input);

        try {
          // showLoader();
          // console.log(inputData);
          const result = await GetAIMedicineComposition(inputData.input);
          // console.log(result);
          if (result) {
            showSuccessToast("Fetched Medicine composition successfully");
            handleEditMedicineChange(
              "composition",
              result.chemical_composition
            );
            handleEditMedicineChange(
              "manufacturer",
              result.Manufacturer
            );
            handleEditMedicineChange(
              "therapeutic",
              result.TherapeuticCategory
            );
            handleEditMedicineChange(
              "drugclass",
              result.DrugClass
            );
            setCompositionEditKey((prevKey) => prevKey + 1);
            // handleNewMedicineChange("medicinetype", result.type);
          }
        } catch (error) {
          console.error("Error Fetching Medicine composition:", error);
          showErrorToast(
            "An error occurred while Fetching Medicine composition"
          );
        } finally {
          // dismissLoader();
        }

        // fetchDoctorNotes();

        // console.log("Clicked");
      }
    };

    //------------------Recommendation code

    // Function to get banner styles based on medicine.from value
    const getBannerStyles = (value) => {
      switch (value) {
        case "new":
          return { bg: "green.500", color: "white" };
        case "recent":
          return { bg: "blue.500", color: "white" };
        case "current":
          return { bg: "gray.500", color: "white" };
        default:
          return { bg: "gray.100", color: "black" }; // Default style
      }
    };

    // function for no data msg

    function checkIndividualFields(jsonInput) {
      if (typeof jsonInput !== "object" || jsonInput === null) {
        return null;
      }

      const {
        chiefcomplaint,
        historyofpresentillness,
        hpitext,
        physicalexamtext,
        rostext,
        physicalexam,
        reviewofsystem,
      } = jsonInput;

      const isArrayNotEmpty = (arr) => Array.isArray(arr) && arr.length > 0;
      const isChiefComplaintNotNull = (obj) => obj && obj.chiefcomplaint;

      const isHPITextNotNull = (obj) => obj && obj.description;
      const isPETextNotNull = (obj) => obj && obj.description;
      const isROSTextNotNull = (obj) => obj && obj.description;

      const fieldStatus = {
        chiefcomplaint: isChiefComplaintNotNull(chiefcomplaint),
        historyofpresentillness:
          isArrayNotEmpty(historyofpresentillness) || isHPITextNotNull(hpitext),
        physicalexam:
          isArrayNotEmpty(physicalexam) || isPETextNotNull(physicalexamtext),
        reviewofsystem:
          isArrayNotEmpty(reviewofsystem) || isROSTextNotNull(rostext),
      };

      const filledCount = Object.values(fieldStatus).filter(Boolean).length;

      return {
        fieldStatus,
        filledCount,
      };
    }

    function renderModalContent(jsonInput) {
      const { fieldStatus, filledCount } = checkIndividualFields(jsonInput);

      const fieldLabels = {
        chiefcomplaint: "Chief Complaint",
        historyofpresentillness: "History of Present Illness",
        physicalexam: "Physical Exam",
        reviewofsystem: "Review of Systems",
      };

      const getMessage = () => {
        if (filledCount >= 2) return null;
        if (filledCount === 1) return "Please fill in one more field.";
        return "Please fill in at least two fields.";
      };

      return (
        <>
          <Text fontSize="14px" fontWeight="600">
            Insufficient data is available to draw inferences. Please ensure
            that relevant notes are provided.
          </Text>
          <ul>
            {Object.entries(fieldStatus).map(([key, isFilled]) => (
              <li
                key={key}
                style={{ textDecoration: isFilled ? "line-through" : "none" }}
              >
                {fieldLabels[key]}
              </li>
            ))}
          </ul>
          {getMessage() && (
            <Text fontSize="14px" fontWeight="600">
              {getMessage()}
            </Text>
          )}
        </>
      );
    }

    //------------------------------AI Feedback

    const [aiInputForFeedback, setAiInputForFeedback] = useState({});
    const [aiOutputForFeedback, setAiOutputForFeedback] = useState({});

    //------------------------------

    function checkFields(jsonInput) {
      // Check if the input is an object
      if (typeof jsonInput !== "object" || jsonInput === null) {
        return false;
      }

      // Extract the necessary fields
      const {
        chiefcomplaint,
        historyofpresentillness,
        hpitext,
        physicalexamtext,
        rostext,
        physicalexam,
        reviewofsystem,
      } = jsonInput;

      // Helper function to check if an array is not empty
      const isArrayNotEmpty = (arr) => Array.isArray(arr) && arr.length > 0;

      // Helper function to check if the chief complaint is not null
      const isChiefComplaintNotNull = (obj) => obj && obj.chiefcomplaint;

      const isHPITextNotNull = (obj) => obj && obj.description;
      const isPETextNotNull = (obj) => obj && obj.description;
      const isROSTextNotNull = (obj) => obj && obj.description;

      // Count the non-null fields
      let nonNullCount = 0;
      if (isChiefComplaintNotNull(chiefcomplaint)) nonNullCount++;

      if (isHPITextNotNull(hpitext)) nonNullCount++;
      if (isPETextNotNull(physicalexamtext)) nonNullCount++;
      if (isROSTextNotNull(rostext)) nonNullCount++;
      if (isArrayNotEmpty(historyofpresentillness)) nonNullCount++;
      if (isArrayNotEmpty(physicalexam)) nonNullCount++;
      if (isArrayNotEmpty(reviewofsystem)) nonNullCount++;

      // Return true if at least two fields are non-null
      return nonNullCount >= 2;
    }

    const [AiInput, setAiInput] = useState(null);

    const fetchRecommendMedicines = async () => {
      showLoader();
      setAiInput(null);

      if (checkFields(doctorNotes) === true) {
        const result = await FetchMyHealthAIData(
          {},
          patientId,
          patientname,
          patientgender,
          patientage
        );
        const doctornotes = doctorNotes;
        const procedures_master_data = inputProceduresMasterData;
        const vaccines_master_data = inputVaccinesMasterData;
        const imaging_master_data = inputImagingMasterData;
        const labs_master_data = inputLabsMasterData;
        const doctor_medicines = inputDoctorFavMedicineData;
        let Aiprompts = {
          ...result,
          doctornotes,
          procedures_master_data,
          vaccines_master_data,
          imaging_master_data,
          labs_master_data,
          doctor_medicines,
        };
        // console.log(Aiprompts);
        // console.log(doctor_medicines);

        setAiInput(Aiprompts);

        setAiInputForFeedback(Aiprompts);
        const response = await AiRecommendMedicines(Aiprompts);
        // console.log("response", response);
        setAiOutputForFeedback(response);
        if (
          response &&
          response?.medicines?.recommended_medicines &&
          response?.medicines?.recommended_medicines?.length > 0
        ) {
          // Adding defaults to ai response

          const formattedMedicines =
            response?.medicines?.recommended_medicines?.map(
              (medicine, index) => ({
                id: index, // Setting the id as the index of the object
                medicinename: medicine.name,
                composition: medicine.composition,
                medicinetype: "Tablet",
                dosage: "",
                dosageunit: "mg",
                medicationstartdate: today, // Default to today
                medicationenddate: fiveDaysFromToday, // Default to 5 days from today
                frequency: 1, // Default value
                morning: 1, // Default value
                evening: 0, // Default value
                night: 0, // Default value
                prescribedby: "",
                hospitalname: "",
                beforefood: 1, // Default value
                afterfood: 0, // Default value
                from: medicine.source,
                reason: medicine?.reason,
                // issaved: false, // Default value
              })
            );

          setRecommendMedicinesAiResponse(formattedMedicines);

          // setRecommendMedicinesAiResponse(response?.recommended_medicines);
          setSelectedRecommendedMedicinesAiResponses([]);
          setSelectedOrderAiResponses([]);

          setEditMedicine(null);
          aiRecommendMedicineRef.current.openModal();
        }
        if (
          response &&
          response?.labs?.recommended_lab &&
          response?.labs.recommended_lab?.length > 0
        ) {
          // recommended labs
          // const formattedLabs = response?.labs?.recommended_lab?.map(
          //   (item, index) => ({
          //     id: item.id,
          //     type: item.type,
          //     subtype: item.subtype,
          //     reason: item.reason,
          //     // category: "labs",
          //   })
          // );
          const formattedLabs = response?.labs?.recommended_lab?.map(
            (item, index) => {
              const { name, reason } = item;

              return {
                name: name,
                reason: reason,
                // category: "labs",
              };
            }
          );
          setRecommendLabsAiResponse(formattedLabs);
          setSelectedOrderAiResponses([]);
        }
        if (
          response &&
          response?.procedures?.recommended_procedures &&
          response?.procedures?.recommended_procedures?.length > 0
        ) {
          // recommended procedures
          // const formattedProcedures =
          //   response?.procedures?.recommended_procedures?.map(
          //     (item, index) => ({
          //       id: item.id,
          //       type: item.type,
          //       subtype: item.subtype,
          //       reason: item.reason,
          //       // category: "procedure",
          //     })
          //   );
          const formattedProcedures =
            response?.procedures?.recommended_procedures?.map((item) => {
              const { name, reason } = item;

              return {
                name: name,
                reason: reason,
              };
            });
          console.log(response?.procedures?.recommended_procedures);
          console.log(formattedProcedures);

          setRecommendProceduresAiResponse(formattedProcedures);
          setSelectedOrderAiResponses([]);
        }
        if (
          response &&
          response?.imaging?.recommended_imaging &&
          response?.imaging?.recommended_imaging?.length > 0
        ) {
          // const formattedImaging = response?.imaging?.recommended_imaging?.map(
          //   (item, index) => ({
          //     id: item.id,
          //     type: item.type,
          //     subtype: item.subtype,
          //     reason: item.reason,
          //     // category: "imaging",
          //   })
          // );
          const formattedImaging = response?.imaging?.recommended_imaging?.map(
            (item, index) => {
              const { name, reason } = item;

              return {
                name: name,
                reason: reason,
                // category: "imaging",
              };
            }
          );
          // recommended imaging
          setRecommendImagingAiResponse(formattedImaging);
          setSelectedOrderAiResponses([]);
        }

        if (
          response?.imaging?.recommended_imaging?.length > 0 ||
          response?.procedures?.recommended_procedures?.length > 0 ||
          response?.labs?.recommended_lab?.length > 0
        ) {
          // Combine all formatted arrays
          const combinedOrderResponses = [
            ...(response?.labs?.recommended_lab?.map((item, index) => ({
              name: item.name,
              reason: item.reason,
              category: "labs",
            })) || []),
            // ...(response?.procedures?.recommended_procedures?.map(
            //   (item, index) => ({
            //     id: item.id,
            //     type: item.type,
            //     subtype: item.subtype,
            //     reason: item.reason,
            //     category: "procedure",
            //   })
            // ) || []),
            ...(response?.procedures?.recommended_procedures?.map(
              (item, index) => ({
                name: item.name,
                reason: item.reason,
                category: "procedure",
              })
            ) || []),

            ...(response?.imaging?.recommended_imaging?.map((item, index) => ({
              name: item.name,
              reason: item.reason,
              category: "imaging",
            })) || []),
          ];
          // const combinedOrderResponses = [
          //   ...(recommendLabsAiResponse || []),
          //   ...(recommendProceduresAiResponse|| []),
          //   ...(recommendImagingAiResponse|| []),
          // ];
          setCombinedOrderAIResponses(combinedOrderResponses);
        } else {
          // noAiResponseModal.current.openModal();
          // setTimeout(() => {
          //   noAiResponseModal.current.closeModal();
          // }, 3000); // 3 seconds delay
          if (noAiResponseModal.current) {
            noAiResponseModal.current.openModal();
            setTimeout(() => {
              if (noAiResponseModal.current) {
                // Check again before closing
                noAiResponseModal.current.closeModal();
              }
            }, 3000); // 3 seconds delay
          }
        }
      } else {
        // noAiResponseModal.current.openModal();
        // setTimeout(() => {
        //   noAiResponseModal.current.closeModal();
        // }, 3000); // 3 seconds delay
        if (noAiResponseModal.current) {
          noAiResponseModal.current.openModal();
          setTimeout(() => {
            if (noAiResponseModal.current) {
              // Check again before closing
              noAiResponseModal.current.closeModal();
            }
          }, 3000); // 3 seconds delay
        }
      }

      dismissLoader();
    };

    // Toggle selection of AI responses
    const handleRecommendedMedicinesCheckboxChange = (index) => {
      setSelectedRecommendedMedicinesAiResponses((prevSelected) =>
        prevSelected.includes(index)
          ? prevSelected.filter((i) => i !== index)
          : [...prevSelected, index]
      );
    };

    const handleRecommendedOrdersCheckboxChange = (index) => {
      setSelectedOrderAiResponses((prevSelected) =>
        prevSelected.includes(index)
          ? prevSelected.filter((i) => i !== index)
          : [...prevSelected, index]
      );
    };

    const transformCheckedAIOrderStateToAPIFormat = async (selectedItems) => {
      // console.log(selectedItems);
      const transformedCategories = {};

      // Mapping for category name adjustments
      const categoryMappings = {
        labs: "lab",
        procedures: "procedure",
        imaging: "imaging",
        vaccinations: "vaccination",
      };

      selectedItems.forEach((item) => {
        let categoryKey = item.category;

        if (categoryMappings[item.category]) {
          categoryKey = categoryMappings[item.category];
        }

        if (!transformedCategories[categoryKey]) {
          transformedCategories[categoryKey] = [];
        }

        transformedCategories[categoryKey].push({
          // ordername_cd: item.id,
          // entitytype: item.type,
          id: null,
          entitytype: categoryKey,
          ordername: item.name,
        });
      });

      // console.log(transformedCategories);

      return transformedCategories;
    };

    const formatDate = (date) => {
      // Check if the date is already in YYYY-MM-DD format
      if (moment(date, "YYYY-MM-DD", true).isValid()) {
        return date;
      }
      // If not, assume it's in DD-MM-YYYY format and convert it to YYYY-MM-DD
      return moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
    };

    const saveSelectedRecommendedMedicinesToOrder = async () => {
      // console.log(selectedRecommendedMedicinesAiResponses); // list of index

      // fetch medicine stored at those index
      const medicinesSelected = selectedRecommendedMedicinesAiResponses.map(
        (index) => recommendMedicinesAiResponse[index]
      );

      const ordersSelected = selectedOrderAiResponses.map(
        (index) => combinedOrderAIResponses[index]
      );

      console.log(medicinesSelected, "medicineSelected");

      const recommendedMedicinesToSave = medicinesSelected.map(
        (medicine, index) => ({
          id: null,
          isactive: 1,
          medicinename: medicine.medicinename,
          chemical_composition: medicine.composition,
          Manufacturer: medicine.manufacturer,
          TherapeuticCategory: medicine.therapeutic,
          DrugClass: medicine.drugclass,
          medicinetype: medicine.medicinetype,
          dosage: medicine.dosage,
          dosageunit: medicine.dosageunit,
          // startdate: moment(medicine.medicationstartdate).format("YYYY-MM-DD"),
          // enddate: moment(medicine.medicationenddate).format("YYYY-MM-DD"),
          startdate: formatDate(medicine.medicationstartdate),
          enddate: formatDate(medicine.medicationenddate),
          frequency: medicine.frequency,
          morning: medicine.morning,
          evening: medicine.evening,
          night: medicine.night,
          // prescribedby: "",
          // hospitalname: "",
          beforefood: medicine.beforefood,
          afterfood: medicine.afterfood,
        })
      );

      const inputData = {
        input: {
          patientid: patientId,
          doctorid: doctorId,
          appointmentid: appointmentId,
          // medicinedetail: recommendedMedicinesToSave,
          ...(recommendedMedicinesToSave.length > 0 && {
            medicinedetail: recommendedMedicinesToSave,
          }),

          // ...(await transformCheckedAIOrderStateToAPIFormat(ordersSelected)),
          ...(ordersSelected.length > 0 && {
            ...(await transformCheckedAIOrderStateToAPIFormat(ordersSelected)),
          }),
        },
      };

      // console.log(inputData);
      try {
        showLoader();
        const result = await updateDoctorNotes(inputData.input);
        // console.log(result);
        if (result) {
          // alert('saveSelectedRecommendedMedicinesToOrder hit')
          showSuccessToast("Selected items saved to orders successfully");
          fetchDoctorNotesEmptyIndication();
          fetchDoctorNotes();
        }
      } catch (error) {
        console.error("Error adding medicine to orders:", error);
        showErrorToast("An error occurred while adding medicine to orders");
      } finally {
        dismissLoader();
      }
    };

    //-----------AI Insights on Recommendation of Diet

    const generateAIDietPlan = async () => {
      const result = await FetchMyHealthAIData(
        {},
        patientId,
        patientname,
        patientgender,
        patientage
      );
      const doctornotes = doctorNotes;
      let AiInput = {
        ...result,
        doctornotes,
      };
      showLoader();
      console.log(AiInput);
      try {
        const data = await RecommendDieticianNotesUsingAI(
          AiInput
        );
        console.log(data);
        setAddAppointmentDieticianNotes(data?.plan);
        // console.log("Generated doctor notes", data);
      } catch (error) {
        console.error("Error fetching AIRA Notes data:", error);
      } finally {
        dismissLoader();
      }
    };



    //-----------AI Insights on Recommendation modal
    const chatContainerRef = useRef(null);
    const [aianswers, setAIAnswers] = useState([]);
    const [remainingquestions, setRemainingQuestions] = useState([]);
    const [aiquestion, setAIAnalysis] = useState(null);
    const [AiInsightsInput, setAiInsightsInput] = useState(null);
    const [initialRender, setInitialRender] = useState(true);
    const [animate, setAnimate] = useState(false);
    const [showAIModal, setShowAIModal] = useState(true);

    const AIChatModel = useRef();

    useEffect(() => {
      if (animate) {
        const timer = setTimeout(() => {
          setAnimate(false);
        }, 500);
        return () => clearTimeout(timer);
      }
    }, [animate]);

    useEffect(() => {
      // Scroll to bottom whenever aianswers changes
      if (chatContainerRef.current) {
        chatContainerRef.current.scrollTop =
          chatContainerRef.current.scrollHeight;
      }
    }, [aianswers]);

    const fetchAiDoctorPrompts = async (medicinename) => {
      showLoader();
      setRemainingQuestions([]);
      setAiInsightsInput(null);
      setAIAnswers([]);
      setInitialRender(true);
      const result = await FetchMyHealthAIData(
        {},
        patientId,
        patientname,
        patientgender,
        patientage
      );
      // console.log(result);
      let Aiprompts = { ...result, medicinename };
      setAiInsightsInput(Aiprompts);
      const response = await FetchMedicineAIPrompts(Aiprompts);
      if (response.generated_question) {
        setAIAnalysis(response);
        setRemainingQuestions(response.generated_question);
        AIChatModel.current.openRight();
      }
      dismissLoader();
    };

    const GetAIAnswer = async (prompt) => {
      // Display question immediately
      const newQuestion = { question: prompt, answer: "" };
      setAIAnswers((prevState) => [...prevState, newQuestion]);

      // Remove the question from remaining questions immediately
      setRemainingQuestions((prevState) =>
        prevState.filter((question) => question.value !== prompt)
      );

      // Trigger animation
      setAnimate(true);

      // Set initialRender to false after the first question is clicked
      setInitialRender(false);
      let AichatInput = { ...AiInsightsInput, query: prompt };

      const response = await FetchMedicineAIAnswer(AichatInput);

      if (response) {
        // Replace "typing" with actual answer
        setAIAnswers((prevState) =>
          prevState.map((item) =>
            item.question === prompt && item.answer === ""
              ? { question: item.question, answer: response.answer }
              : item
          )
        );
      }
    };

    //-----------search overlay

    const [searchValue, setSearchValue] = useState("");

    const [searchMasterData, setSearchMasterData] = useState([]);
    const [labsMasterData, setLabsMasterData] = useState([]);
    const [imagingMasterData, setImagingMasterData] = useState([]);
    const [proceduresMasterData, setProceduresMasterData] = useState([]);
    const [vaccinesMasterData, setVaccinesMasterData] = useState([]);

    const { isLoading, showLoader, dismissLoader } = useLoader();

    const dynamicModalPrescriptionDiscard = useRef();

    const fetchMasterData = async (category) => {
      try {
        const inputData = {
          input: {
            type: category,
            doctorid: doctorId,
            appointmentid: appointmentId,
          },
        };
        // console.log(inputData);
        const data = await GetDoctorMasterData(inputData.input);
        // Add "category" key to each object in the array
        const modifiedData = data.map((item) => {
          return { ...item, category: category };
        });
        // console.log(modifiedData);
        return modifiedData;
      } catch (error) {
        console.error("Error fetching Master data:", error);
        return [];
      }
    };

    // const [recentMedicines, setRecentMedicines] = useState([]);

    function processRecentMedicationsData(medicationArray) {
      if (!medicationArray || medicationArray.length === 0) {
        return [];
      }

      const today = moment().format("DD-MM-YYYY");
      const fiveDaysFromToday = moment().add(5, "days").format("DD-MM-YYYY");

      return medicationArray.map((med) => ({
        id: med.id,
        category: "medicine",
        type: med.medicinetype,
        subtype: med.medicinename,
        medicinename: med.medicinename,
        medicinetype: med.medicinetype,
        dosage: med.dosage,
        dosageunit: med.dosageunit,
        medicationstartdate: today,
        medicationenddate: fiveDaysFromToday,
        duration:
          Math.abs(
            new Date(med.medicationstartdate) - new Date(med.medicationenddate)
          ) /
            (1000 * 60 * 60 * 24) +
          " days",
        frequency: med.frequency,
        morning: med.morning,
        evening: med.evening,
        night: med.night,
        beforefood: med.beforefood,
        afterfood: med.afterfood,
        composition: med.chemicalcomposition,
      }));
    }

    const fetchRecentMedicines = async () => {
      // console.log("Function called");
      const inputToFetch = {
        input: {
          doctorid: doctorId,
        },
      };
      // showLoader();
      try {
        const data = await GetDoctorFavMedicine(inputToFetch.input);
        // console.log(data?.output?.data);
        // console.log(processRecentMedicationsData(data?.output?.data));
        return processRecentMedicationsData(data?.output?.data);
      } catch (error) {
        console.error("Error fetching Recent Medications data:", error);
      } finally {
        // dismissLoader();
      }
    };

    const fetchSearchPanelData = async () => {
      try {
        const labsData = fetchMasterData("labs");
        const imagingData = fetchMasterData("imaging");
        const proceduresData = fetchMasterData("procedures");
        const vaccinesData = fetchMasterData("vaccine");
        const recentMedicines = fetchRecentMedicines();

        const [labs, imaging, procedures, vaccine, medicines] = await Promise.all([
          labsData,
          imagingData,
          proceduresData,
          vaccinesData,
          recentMedicines,
        ]);

        setLabsMasterData(labs);
        setImagingMasterData(imaging);
        setProceduresMasterData(procedures);
        setVaccinesMasterData(vaccine);

        const masterData = [
          ...labs,
          ...imaging,
          ...procedures,
          ...vaccine,
          ...medicines,
        ].filter((item) => {
          if (!item.type) {
            // If item exists but doesn't have a type, set "No Type"
            item.type = "No Type";
          }

          // Return true if the type is not "other", otherwise false
          return item.type.toLowerCase() !== "other";
        });

        // console.log(masterData);

        setSearchMasterData(masterData);

        // console.log(searchMasterData);
      } catch (error) {
        console.error("Error fetching Search Master data:", error);
      }
    };

    const openSearch = useRef();
    useImperativeHandle(searchRef, () => ({
      openSearchOverlay: () => {
        fetchSearchPanelData();
        // console.log("Hello from Search!");
        openSearch.current.openRight();
      },
    }));

    const [selectedItems, setSelectedItems] = useState([]);

    const handleCheckboxChange = (item) => {
      setSelectedItems((prevSelectedItems) => {
        if (
          prevSelectedItems.some((selectedItem) => selectedItem.id === item.id)
        ) {
          // If the item is already selected, remove it from the selected items
          return prevSelectedItems.filter(
            (selectedItem) => selectedItem.id !== item.id
          );
        } else {
          // Otherwise, add the item to the selected items
          if (item.category === "medicine") {
            // console.log("case encountered");
            return [
              ...prevSelectedItems,
              {
                ...item,
                category: item.category,
                id: item.id,
                subtype: item.subtype,
              }, // Copy the entire 'item' object
            ];
          } else {
            return [
              ...prevSelectedItems,
              { category: item.category, id: item.id, subtype: item.subtype },
            ];
          }
        }
      });
    };

    const isChecked = (id) => {
      return selectedItems.some((selectedItem) => selectedItem.id === id);
    };

    function transformMedicineSearchStateToApiInput(med) {
      // console.log(med);
      const today = moment().format("YYYY-MM-DD");
      const fiveDaysFromToday = moment().add(5, "days").format("YYYY-MM-DD");

      const frequency =
        med.frequency ||
        (med.morning ? 1 : 0) + (med.evening ? 1 : 0) + (med.night ? 1 : 0);

      return {
        id: null,
        medicinename: med.medicinename,
        medicinetype: med.medicinetype,
        dosage: med.dosage,
        dosageunit: med.dosageunit,
        startdate: today,
        enddate: fiveDaysFromToday,
        frequency: frequency,
        morning: med.morning,
        evening: med.evening,
        night: med.night,
        beforefood: med.beforefood,
        afterfood: med.afterfood,
        chemical_composition: med.composition,
        Manufacturer: med.manufacturer,
        TherapeuticCategory: med.therapeutic,
        DrugClass: med.drugclass,
        isactive: 1,
      };
    }

    const transformSearchStateToAPIFormat = (selectedItems) => {
      const transformedCategories = {};

      // Mapping for category name adjustments
      const categoryMappings = {
        labs: "lab",
        procedures: "procedure",
        medicine: "medicinedetail",
        vaccinations: "vaccination",
      };

      selectedItems.forEach((item) => {
        let categoryKey = item.category;
        let entityType = item.category;

        if (categoryMappings[item.category]) {
          categoryKey = categoryMappings[item.category];
          entityType = categoryMappings[item.category];
        }

        if (!transformedCategories[categoryKey]) {
          transformedCategories[categoryKey] = [];
        }

        if (categoryKey === "medicinedetail") {
          // console.log(item);
          const transformedMedicine =
            transformMedicineSearchStateToApiInput(item);
          transformedCategories[categoryKey].push(transformedMedicine);
        } else {
          transformedCategories[categoryKey].push({
            id: item.id,
            entitytype: entityType,
            ordername: item.subtype,
          });
        }
      });

      return transformedCategories;
    };

    const handleSearchSaveButtonClick = async () => {
      if (selectedItems.length === 0) {
        showErrorToast("Please select any value to save");
        openSearch.current.closeRight();
        return false;
      }

      const inputToSave = {
        input: {
          doctorid: doctorId,
          patientid: patientId,
          appointmentid: appointmentId,
          // ...(currentOrderType === "vaccination" ? { vaccineappointmentid: appointmentId } : { appointmentid: appointmentId }),
          ...transformSearchStateToAPIFormat(selectedItems),
        },
      };

      // console.log(inputToSave);

      try {
        const result = await updateDoctorNotes(inputToSave.input);
       
        if (result) {
          // alert('handleSearchSaveButtonClick hit')
          showSuccessToast("Order Saved successfully");
          fetchDoctorNotesEmptyIndication();

          setSelectedItems([]);
          setSearchValue("");

          openSearch.current.closeRight();
        }
      } catch (error) {
        console.error("Error in Update Doctor Notes:", error);
        showErrorToast("Error Happened While Saving.");
        openSearch.current.closeRight();
      }
      fetchDoctorNotes();
    };

    const openSearchSpecificOrder = useRef();

    const [specificSearchOrderData, setSpecificSearchOrderData] = useState([]);

    const openSpecificSearchOrderOverlay = async (category) => {
      let dataCategory = "";
      if (category === "lab") {
        dataCategory = "labs";
      } else if (category === "vaccination") {
        dataCategory = "vaccination"
      } else if (category === "procedure") {
        dataCategory = "procedures";
      } else {
        dataCategory = category;
      }

      try {
        const result = await fetchMasterData(dataCategory); // Await the promise to get the resolved data
        const filteredResult = result.filter((item) => {
          if (!item.type) {
            // If item exists but doesn't have a type, set "No Type"
            item.type = "No Type";
          }

          // Return true if the type is not "other", otherwise false
          return item.type.toLowerCase() !== "other";
        });
        setSpecificSearchOrderData(filteredResult);
        addOrder.current.closeRight();
        setSearchValue('')
        openSearchSpecificOrder.current.openRight();
      } catch (error) {
        console.error("Error fetching specific search order data:", error);
        showErrorToast("Error fetching specific search order data.");
      }
    };

    const handleSpecificOrderSearchSaveButtonClick = async () => {
      const inputToSave = {
        input: {
          doctorid: doctorId,
          patientid: patientId,
          appointmentid: appointmentId,
          // ...(currentOrderType === "vaccination" ? { vaccineappointmentid: appointmentId } : { appointmentid: appointmentId }),
          ...transformSearchStateToAPIFormat(selectedItems),
        },
      };

      // console.log(inputToSave);

      try {
        const result = await updateDoctorNotes(inputToSave.input);
        if (result) {
          // alert('handleSpecificOrderSearchSaveButtonClick hit')
          showSuccessToast("Order Saved successfully");

          fetchDoctorNotesEmptyIndication();
          setSelectedItems([]);
          setSearchValue("");

          openSearchSpecificOrder.current.closeRight();
        }
      } catch (error) {
        console.error("Error in Update Doctor Notes:", error);
        showErrorToast("Error Happened While Saving.");
        openSearchSpecificOrder.current.closeRight();
        addOrder.current.closeRight();
      }
      fetchDoctorNotes();
    };

    // ---------------
    // Throughout Code, Order refers to Procedure, Labs & Imaging

    const addOrder = useRef(); // for Procedure, Labs and Imaging
    const addPrescription = useRef(); // for medication
    const addCondition = React.useRef();
    const addCondition2 = React.useRef();

    const handleCheckboxChangeVaccine = (condition) => {
          const isSelected = selectedConditions.some(
            (item) => item.condition_cd === condition.condition_cd
          );
    
          if (isSelected) {
            setSelectedConditions((prevConditions) =>
              prevConditions.filter(
                (item) => item.condition_cd !== condition.condition_cd
              )
            );
    
            setSelectedDates((prevDates) => {
              const updatedDates = { ...prevDates };
              delete updatedDates[condition.condition_cd]; // Remove the date for the deselected condition
              return updatedDates;
            });
            setSelectedDueDates((prevDates) => {
              const updatedDates = { ...prevDates };
              delete updatedDates[condition.condition_cd]; // Remove the date for the deselected condition
              return updatedDates;
            });
          } else {
             // If the condition is not selected, add it and set the date to the first date of the current month
                 const now = new Date();
                 const firstDateOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
                 const formattedDate = format(firstDateOfMonth, "yyyy-MM-dd");
                 setSelectedDates((prevDates) => ({
                  ...prevDates,
                  [condition.condition_cd]: formattedDate,
                }));
                setSelectedDueDates((prevDates) => ({
                  ...prevDates,
                  [condition.condition_cd]: formattedDate,
                }));
    
            setSelectedConditions([...selectedConditions, condition]);
          }
        };

    var [conditionsList, setConditionsList] = useState(null);
        // const [searchValue, setSearchValue] = useState("");
            const [typedCondition, setTypedCondition] = useState("");
        const [selectedConditions, setSelectedConditions] = useState([]);
        const [selectedDates, setSelectedDates] = useState({});
        const [selectedDueDates, setSelectedDueDates] = useState({});

        const handleCondition = (e) => {
      const inputText = e.target.value;
      const maxLength = 80;

      if (inputText.length <= maxLength) {
        setTypedCondition(inputText);
      }
    };
    const [actionAccessPatients, setActionAccessPatients] = useState(null);
        useEffect(() => {
          setActionAccessPatients(actionAccessMain(4));
        }, []);
        const scrollDiv = useRef(null);

    const [minDateState, setMinDateState] = useState("");
        const [maxDateState, setMaxDateState] = useState("");
        const handleDateChange = (conditionCd, date) => {
          const formattedDate = format(date, "yyyy-MM-dd");
          setMinDateState(date);
          setSelectedDates((prevDates) => ({
            ...prevDates,
            [conditionCd]: formattedDate,
          }));
        };
        const handleDueDateChange = (conditionCd, date) => {
          setMaxDateState(date);
          const formattedDate = format(date, "yyyy-MM-dd");
          setSelectedDueDates((prevDates) => ({
            ...prevDates,
            [conditionCd]: formattedDate,
          }));
        };

    const prescriptionComponentRef = useRef(null);

    const handleSaveButtonClick = () => {
      if (prescriptionComponentRef.current) {
        prescriptionComponentRef.current.saveMedicineToOrders();
        prescriptionComponentRef.current.saveCurrentPatientMedicineToOrders();
      }
      // addPrescription.current.closeRight();
      fetchDoctorNotes();
      fetchPatientHealthData();
      fetchDoctorNotesEmptyIndication();
    };

    // states to have add orders functionality
    const [currentOrderType, setCurrentOrderType] = useState(""); // Procedure, Labs or Imaging
    const [currentOrderNames, setCurrentOrderNames] = useState([
      { id: 1, name: "" },
    ]);

    const [orderInputFields, setOrderInputFields] = useState([{ id: 1 }]);

    // states to store fetched doctor notes
    const [currentLabData, setCurrentLabData] = useState([]);
    const [currentVaccinationData, setCurrentVaccinationData] = useState([]);
    const [navBarData, setNavBarData] = useState([]);
    const [currentCCData, setCurrentCCData] = useState('');
    const [currentImagingData, setCurrentImagingData] = useState([]);
    const [currentProcedureData, setCurrentProcedureData] = useState([]);
    const [currentMedicationData, setCurrentMedicationData] = useState([]);

    // State for disabling/enabling save button
    const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(false);

    const addOrderInputField = () => {
      const newId = orderInputFields.length + 1;
      setOrderInputFields([...orderInputFields, { id: newId }]);
      setCurrentOrderNames([...currentOrderNames, { id: newId, name: "" }]);
    };

    const deleteOrderInputField = (id) => {
      setOrderInputFields(orderInputFields.filter((field) => field.id !== id));
      setCurrentOrderNames(
        currentOrderNames.filter((order) => order.id !== id)
      );
    };

    const fetchMedicalConditionList = async () => {
          try {
            const result = await getVaccineList({
              type: "vaccine",
              patientid: patientId,
            });
            if (result.output.result == "success") {
              setConditionsList(result.output.data);
            } else {
              showErrorToast("Something went wrong!");
            }
          } catch (error) {
            console.error("Error", error);
          }
        };
        var inputForAdd = {
      patientid: patientId,
      doctorid: getLoginID(),
      vaccineappointmentid: appointmentId,
      vaccination: selectedConditions.map((condition, index) => ({
        vaccine_cd: condition.condition_cd,
        vaccinename: condition.condition,
        admindate: selectedDates[condition.condition_cd] || null,
        duedate: selectedDueDates[condition.condition_cd] || null,
        // "documents": uploadedDocuments
        // .filter((doc) => doc.condition_cd == condition.condition_cd)
        // .map(({ condition_cd, filename }) => ({
        //   condition_cd,
        //   filename,
        // })),
      })),
    };
        const AddMedicalConditions = () => {
              if (selectedConditions.length === 0 && typedCondition == "") {
                showErrorToast("Please Select a Vaccine to Continue");
              } else {
                // enter manually
                if (typedCondition !== "") {
                  const newSelectedCondition = {
                    condition: typedCondition,
                    condition_cd: null,
                    conditiontype: "other",
                  };
        
                  setSelectedConditions((prevConditions) => {
                    // Filter out any existing condition with the same type
                    const filteredConditions = prevConditions.filter(
                      (item) => item?.conditiontype !== "other"
                    );
                    // Add the new condition
                    return [...filteredConditions, newSelectedCondition];
                  });
                }
        
                //--------------------------------
                // setSelectedDates({});
                // setSelectedDueDates({});
                addCondition2.current.openRight();
              }
            };
        
const AddMedicalConditionsCall = () => {
      const addConditions = async () => {
        showLoader();
        try {
          const result = await addVaccination(inputForAdd);
          if (result.output.result == "success") {
            showSuccessToast("Successfully Added");
            if (scrollDiv.current) {
              scrollDiv.current.scrollTop = 0;
            }

            // fetchPatientHealthData();
            fetchDoctorNotes();

            addCondition2.current.closeRight();
            addCondition.current.closeRight();
          } else {
            showErrorToast("Something went wrong!");
          }
        } catch (error) {
          console.error("Error in DashboardIndex:", error);
        }
        dismissLoader();
      };

      const isDateMissing = selectedConditions.some(
        // (condition) => !selectedDates[condition.condition_cd] || !selectedDueDates[condition.condition_cd]
        (condition) => !selectedDates[condition.condition_cd]
      );

      if (isDateMissing) {
        showErrorToast("Please select admin date");
        return false;
      } else {
        addConditions();
      }
    };

    const openAddOrder = (orderType) => {
      setOrderInputFields([{ id: 1 }]); // reset to one input box, whenever opened;
      setCurrentOrderType(orderType); // set the current order type
      setIsSaveButtonDisabled(false); // enable save button when modal opens
      if(orderType === 'vaccination'){
        fetchMedicalConditionList();
      // }
      setSearchValue("");
      setSelectedConditions([]);
      setSelectedDueDates({});
      setTypedCondition("");
        if(addCondition.current) {
          addCondition.current.openRight();
        }
      }else {
        if (addOrder.current) {
          addOrder.current.openRight();
        } 
      }
    };
    // const openAddOrder = (orderType) => {
    //   setOrderInputFields([{ id: 1 }]); // reset to one input box, whenever opened;
    //   setCurrentOrderType(orderType); // set the current order type
    //   setIsSaveButtonDisabled(false); // enable save button when modal opens
    //   if (addOrder.current) {
    //     addOrder.current.openRight();
    //   }
    // };

    const openAddPrescription = () => {
      if (addPrescription.current) {
        addPrescription.current.openRight();
      }
    };

    const handleAddOrderName = (id, value) => {
      setCurrentOrderNames((prevNames) =>
        prevNames.map((order) =>
          order.id === id ? { ...order, name: value } : order
        )
      );
    };

    //   ---- Fetch Doctor Notes -----

    function processMedicationsData(medicationArray) {
      if (!medicationArray || medicationArray.length === 0) {
        return [];
      }


      return medicationArray.map((med) => {
        const durationParts = med.duration?.split(' ') || [];
        const durationValue = durationParts[0] ? parseInt(durationParts[0]) : 5;
        const durationUnit = durationParts[1] || 'Days';
      return {
        id: med.id,
        name: med.medicinename,
        type: med.medicinetype,
        dosage: med.dosage,
        dosageunit: med.dosageunit,
        startdate: moment(med.medicationstartdate, "YYYY-MM-DD").format(
          "DD-MM-YYYY"
        ),
        enddate: moment(med.medicationenddate, "YYYY-MM-DD").format(
          "DD-MM-YYYY"
        ),
        duration:
          Math.abs(
            new Date(med.medicationstartdate) - new Date(med.medicationenddate)
          ) /
            (1000 * 60 * 60 * 24) +
          1 +
          " days",
        frequency: med.frequency,
        inMorning: med.morning,
        inAfternoon: med.afternoon,
        inEvening: med.evening,
        inNight: med.night,
        beforefood: med.beforefood,
        afterfood: med.afterfood,
        chemicalcomposition: med.chemicalcomposition,

        // ----- new

        routeofadministration: med.routeofadministration,
        timingofinjection: med.timingofinjection,
        quantitytobeapplied: med.quantitytobeapplied,
        areaofapplication: med.areaofapplication,
        diluent: med.diluent,
        additives: med.additives,

        rateofinfusionvalue: med.rateofinfusionvalue,
        rateofinfusionunit: med.rateofinfusionunit,
        sos: med.sos,
        custommessage  : med.custommessage,
        frequencytime: med.frequencytime,
        frequencyvalue: med.frequencyvalue,
        durationvalue: durationValue,
        durationunit: durationUnit,
        medicationstartdate: moment(med.medicationstartdate, "YYYY-MM-DD").format(
          "DD-MM-YYYY"
        ),
        medicationenddate: moment(med.medicationenddate, "YYYY-MM-DD").format(
          "DD-MM-YYYY"
        ),
      }
    });
    }

    const fetchDoctorNotes = async () => {
      const inputToFetch = {
        input: {
          patientid: patientId,
          doctorid: doctorId,
          appointmentid: appointmentId,
        },
      };

      showLoader();
      try {
        const data = await GetDoctorNotes(inputToFetch.input);
        setDoctorNotes(data?.output?.data);
        setCurrentLabData(data.output.data?.orders?.lab);
        setCurrentVaccinationData(data.output.data?.orders?.vaccinationdetail);
        setCurrentCCData(data.output.data?.chiefcomplaint?.chiefcomplaint);
        setNavBarData(data.output.data)
        setCurrentImagingData(data.output.data?.orders?.imaging);
        setCurrentProcedureData(data.output.data?.orders?.procedure);
        setCurrentMedicationData(
          processMedicationsData(data.output.data?.orders?.medication)
        );
        setDieticianNotes(data.output.data?.dieticiannote)
        setGeneralDieticianNotes(data.output.data?.generalnotes)
      } catch (error) {
        console.error("Error fetching Doctor Notes data:", error);
      } finally {
        dismissLoader();
      }
    };
    // dietician notes start
    const addDieticianNotes = async () => {
      const inputToSave = {
        input: {
          appointmentid: appointmentId,
          doctorid: doctorId,
          dietnotedetail: [
            {
              dietnote: addAppointmentDieticianNotes
            }
          ]
        }
      }

        try {
          const result = await createAppointmentDieticianNotes(inputToSave.input);
          setAddAppointmentDieticianNotes('')
          fetchDoctorNotes()
          return result;
        } catch (error) {
          console.error("Error in Add Dietician Notes:", error);
          throw error;
        }
      };

      function openDieticianModal(id, operation, value){
        setDeleteDieticianId(id)
        if(operation === 'edit'){
          setUpdateDieticianNotes(value)
          editDieticianNotesModal.current.openModal()
        } else {
          deleteDieticianNotesModal.current.openModal()
        }
      }

      async function deleteDieticianNote(){
        const inputToDelete = {
            input: {
              appointmentid: appointmentId,
              doctorid: doctorId,
              id: deleteDieticianId
            }
        }

        try {
          const result = await deleteAppointmentDieticianNotes(inputToDelete.input);
          setDeleteDieticianId("")
          fetchDoctorNotes();
          return result;
        } catch (error) {
          console.log('Error deleting Ditiecian notes', error)
          throw error;
        }
      }

      async function editDieticianNotes(){
        const inputToUpdate = {
          input: {
            appointmentid: appointmentId,
            doctorid: doctorId,
            id: deleteDieticianId,
            dietnote: addAppointmentDieticianNotes
          }
        }

        try {
          const result = await createAppointmentDieticianNotes(inputToUpdate.input);
          setUpdateDieticianNotes('')
          setAddAppointmentDieticianNotes('')
          fetchDoctorNotes()
          return result;
        } catch (error) {
          console.log('Error in updating Dietician notes', error)
          throw error;
        }
      }

    // Dietiician notes end

    // general dietician notes start
    const addGeneralDieticianNotes = async () => {
      const inputToSave = {
        input: {
          appointmentid: appointmentId,
          doctorid: doctorId,
          generalnotedetail: [
            {
              generalnote: addGeneralAppointmentDieticianNotes || textFieldValue
              // generalnote: addGeneralAppointmentDieticianNotes ? addGeneralAppointmentDieticianNotes : textFieldValue
            }
          ]
        }
      }

        try {
          const result = await createGeneralAppointmentDieticianNotes(inputToSave.input);
          setAddGeneralAppointmentDieticianNotes('')
          setValue('textField', '')
          fetchDoctorNotes()
          return result;
        } catch (error) {
          console.error("Error in Add Dietician Notes:", error);
          throw error;
        }
      };

      function openGeneralDieticianModal(id, operation, value){
        setGeneralDeleteDieticianId(id)
        if(operation === 'edit'){
          setUpdateGeneralDieticianNotes(value)
          editGeneralDieticianNotesModal.current.openModal()
        } else {
          deleteGeneralDieticianNotesModal.current.openModal()
        }
      }

      async function deleteGeneralDieticianNote(){
        const inputToDelete = {
            input: {
              appointmentid: appointmentId,
              doctorid: doctorId,
              id: deleteGeneralDieticianId
            }
        }

        try {
          const result = await deleteGeneralAppointmentDieticianNotes(inputToDelete.input);
          setGeneralDeleteDieticianId("")
          fetchDoctorNotes();
          return result;
        } catch (error) {
          console.log('Error deleting Ditiecian notes', error)
          throw error;
        }
      }

      async function editGeneralDieticianNotes(){
        const inputToUpdate = {
          input: {
            appointmentid: appointmentId,
            doctorid: doctorId,
            id: deleteGeneralDieticianId,
            generalnote: addGeneralAppointmentDieticianNotes
          }
        }

        try {
          const result = await createGeneralAppointmentDieticianNotes(inputToUpdate.input);
          setUpdateGeneralDieticianNotes('')
          setAddGeneralAppointmentDieticianNotes('')
          setValue('')
          fetchDoctorNotes()
          return result;
        } catch (error) {
          console.log('Error in updating Dietician notes', error)
          throw error;
        }
      }

    // Dietiician notes end

    useEffect(() => {
      fetchDoctorNotes();
    }, []);

    useImperativeHandle(ref, () => ({
      updateOrderFromPatientMedication: fetchDoctorNotes,
    }));

    // ------- ADD ORDER --------------------

    const transformStateToAPIFormat = (currentOrderType, currentOrderNames) => {
      return currentOrderNames
        .filter((order) => order.name.trim() !== "") // Filter out empty strings
        .map((order) => ({
          id: null,
          entitytype: currentOrderType,
          ordername: order.name,
        }));
    };
//     const transformStateToAPIFormat = (orderType, orderNames) => {
//   if (orderType === "vaccination") {
//     return orderNames.map(order => ({
//       entitytype: "vaccination",
//       ordername: order.name,
//       // Add any additional vaccination-specific fields here
//     }));
//   }
  
//   // Default transformation for other order types
//   return orderNames.map(order => ({
//     entitytype: orderType,
//     ordername: order.name,
//   }));
// };

    const AddOrder = async () => {
      const hasEmptyOrderName = currentOrderNames.some(
        (order) => order.name.trim() === ""
      );

      // if (hasEmptyOrderName) {
      //   showErrorToast(`${currentOrderType} name cannot be empty.`);
      //   return;
      // }
      const inputToSave = {
        input: {
          doctorid: doctorId,
          patientid: patientId,
          appointmentid: appointmentId,
          // ...(currentOrderType === "vaccination" ? { vaccineappointmentid: appointmentId } : { appointmentid: appointmentId }),
          [currentOrderType]: transformStateToAPIFormat(
            currentOrderType,
            currentOrderNames
          ),
        },
      };
      // console.log(inputToSave);
      try {
        setIsSaveButtonDisabled(true); // disable save button on submit
        const result = await updateDoctorNotes(inputToSave.input);
        
        if (result) {
          // alert('AddOrder hit')
          showSuccessToast(`${currentOrderType} Saved successfully.`);
          fetchDoctorNotesEmptyIndication();
          // Reset order names and input fields
          setCurrentOrderNames([{ id: 1, name: "" }]);
          setOrderInputFields([{ id: 1 }]);

          setCurrentOrderType(""); // Reset order type

          // also fetch data here
          addOrder.current.closeRight();
        }
      } catch (error) {
        console.error("Error in Update Doctor Notes:", error);
        showErrorToast("Error Happened While Saving.");
        addOrder.current.closeRight();
      }
      fetchDoctorNotes();
    };

    const handleAddPrescription = (event) => {
      event.stopPropagation(); // To make sure that it does not expand when interacting with buttons
      openAddPrescription();
    };

    const handleAddProcedure = (event) => {
      event.stopPropagation(); // To make sure that it does not expand when interacting with buttons
      openAddOrder("procedure");
    };

    const handleAddLabs = (event) => {
      event.stopPropagation(); // To make sure that it does not expand when interacting with buttons
      openAddOrder("lab");
    };

    const handleAddVaccinations = (event) => {
      event.stopPropagation(); // To make sure that it does not expand when interacting with buttons
      openAddOrder("vaccination");
    };

    const handleAddImaging = (event) => {
      event.stopPropagation(); // To make sure that it does not expand when interacting with buttons
      openAddOrder("imaging");
    };

    // Index is based on position of these elements in UI
    // Whenever layout in UI changes, this should change as well.
    // const getInitialExpandedIndices = () => {
    //   const expandedIndices = [];
    //   if (currentMedicationData && currentMedicationData.length > 0)
    //     expandedIndices.push(0);
    //   if (currentProcedureData && currentProcedureData.length > 0)
    //     expandedIndices.push(1);
    //   if (currentLabData && currentLabData.length > 0) expandedIndices.push(2);
    //   if (currentImagingData && currentImagingData.length > 0)
    //     expandedIndices.push(3);
    //   return expandedIndices;
    // };

    const [expandedIndices, setExpandedIndices] = useState([]);
    // console.log(expandedIndices);

    // Index is based on position of these elements in UI
    // Whenever layout in UI changes, this should change as well.
    useEffect(() => {
      const expandedIndices = [];
      if (currentMedicationData && currentMedicationData.length > 0)
        expandedIndices.push(0);
      if (currentProcedureData && currentProcedureData.length > 0)
        expandedIndices.push(1);
      if (currentLabData && currentLabData.length > 0) expandedIndices.push(2);
      if (currentImagingData && currentImagingData.length > 0)
        expandedIndices.push(3);
      if(dieticianNotes && dieticianNotes.length > 0) expandedIndices.push(4);
      if(generalDieticianNotes && generalDieticianNotes.length > 0) expandedIndices.push(5);
      setExpandedIndices(expandedIndices);
      if (currentVaccinationData && currentVaccinationData.length > 0) expandedIndices.push(6);

    }, [
      currentMedicationData,
      currentProcedureData,
      currentLabData,
      currentImagingData,
      currentVaccinationData
    ]);


    const generateDynamicText = (item, gender, dob) => {
    let outputTexts = [];
    if(item.details == null){
      return false;
    }
    // Retrieve stored data from localStorage
    let storedData = localStorage.getItem("dobAndGenderData");
    let parsedData = storedData ? JSON.parse(storedData) : {};
    let genderFromStorage = parsedData.gender || "";
    let dobFromStorage = parsedData.dob || "";

    // Use provided gender and dob or fallback to localStorage data
    let genderToUse = gender || genderFromStorage;
    let dobToUse = dob || dobFromStorage;
    let age = calculateAge(dobToUse);

    let attributes = {};
    if (item.details && Array.isArray(item.details) && item.details.length < 0) {
      return;
    }
    // Parse the item details to extract attributes
    if (item.details && Array.isArray(item.details)) {
      item.details.forEach((attribute) => {
        switch (attribute.attribute) {
          case "Site":
            attributes.site = attribute.values.map((v) => v.value).join(", ");
            break;
          case "Onset":
            attributes.onset = attribute.value;
            break;
          case "Chronicity":
            attributes.chronicity = attribute.value;
            break;
          case "Onset Quality":
            attributes.onsetQuality = attribute.value;
            break;
          case "Frequency":
            attributes.frequency = attribute.value;
            break;
          case "Associated Symptoms":
            attributes.symptoms = attribute.values
              .map((v) => v.value)
              .join(", ");
            break;
          case "Rating Scale":
            attributes.ratingScale = attribute.value;
            break;
          case "Time":
            attributes.time = attribute.value;
            break;
          case "Time Value":
            attributes.timeValue = attribute.value;
            break;
          default:
            break;
        }
      });
    }

    // Generate the patient introductory text
    let patientText = `The patient is a ${
      isNaN(age) ? "" : age
    }-year-old individual (${genderToUse}) `;
    let template = `${patientText}`;

    // Add each attribute's sentence only if the data is available
    if (attributes.site) {
      template += `presenting with ${attributes.site} ${item.type}. `;
    }

    if (attributes.onset) {
      template += `The ${item.type} started ${attributes.onset} and `;
      if (attributes.chronicity) {
        template += `is described as ${attributes.chronicity} in nature. `;
      }
    }

    if (attributes.onsetQuality) {
      template += `The onset of the ${item.type} was ${attributes.onsetQuality}. `;
    }

    if (attributes.frequency) {
      template += `The ${item.type} is ${attributes.frequency} and `;
    }

    if (attributes.ratingScale) {
      template += `is rated as ${attributes.ratingScale} out of 10 in intensity. `;
    }

    if (attributes.symptoms) {
      template += `Associated with ${attributes.symptoms}.`;
    }

    // Push the generated template to the outputTexts array
    outputTexts.push(template.trim());

    return outputTexts;
  };
    

  const vitalNameShortMap = {
  "Body temperature": "Temp",
  "Pulse": "Heart Rate",
  "Respiratory rate": "Resp Rate",
  "Oxygen Saturation": "SPO2",
  "Systolic Blood Pressure": "BP Systolic",
  "Diastolic Blood Pressure": "BP Diastolic",
  "Fasting Blood Glucose": "Fasting Sugar",
  "Postprandial Blood Glucose": "Post-Prandial Sugar",
  // "Weight": "Weight",
  // "Height": "Height",
  // add more mappings if needed
};

const isChatbotAllowed = () => {
  const subscriptionName = localStorage.getItem("subscriptionName");
  const subscriptionEndDate = localStorage.getItem("subscriptionEndDate");
  
  // If either value is missing, assume chatbot is allowed (or you can handle differently)
  if (!subscriptionName || !subscriptionEndDate) return true;
  
  // Check if subscription is Basic and end date has passed
  const currentDate = new Date();
  const endDate = new Date(subscriptionEndDate);
  
  // return !(subscriptionName === "Basic");
  return !(subscriptionName === "Basic" && currentDate > endDate);
};

// ------------------------------ Recorder ------------------------------------------
const activeTranscriberGeneral = useGPUTranscriber(); // For General Notes
const activeTranscriberDietician = useGPUTranscriber(); // For Dietician Notes

const [typingGeneral, setTypingGeneral] = useState(false);
const [typingDietician, setTypingDietician] = useState(false);

const [placeholderGeneral, setPlaceholderGeneral] = useState("Click anywhere to start typing....");
const [placeholderDietician, setPlaceholderDietician] = useState("Click anywhere to start typing....");

// Effect for General Notes transcriber - ONLY updates General Notes
useEffect(() => {
  if (activeTranscriberGeneral?.output?.text) {
    setAddGeneralAppointmentDieticianNotes(activeTranscriberGeneral.output.text);
    setPlaceholderGeneral("Click anywhere to start typing....");
    setTypingGeneral(false);
  }
}, [activeTranscriberGeneral?.output]);

// Effect for Dietician Notes transcriber - ONLY updates Dietician Notes
useEffect(() => {
  if (activeTranscriberDietician?.output?.text) {
    setAddAppointmentDieticianNotes(activeTranscriberDietician.output.text);
    setPlaceholderDietician("Click anywhere to start typing....");
    setTypingDietician(false);
  }
}, [activeTranscriberDietician?.output]);

//------------------other functionality
const { register, handleSubmit, watch, setValue } = useForm();
const textFieldValue = watch("textField", "");
const [isButtonDisabled, setIsButtonDisabled] = useState(false);
const [initialText, setInitialText] = useState("");
const advanceCheifComplaints = useRef();

const correctChiefComplaint = async (cc_text) => {
  console.log('cc_text: ', cc_text)
  const inputToSave = {
    input: {
      text: cc_text,
      type: "General Notes"
    },
  };

  showLoader();
  try {
    const result = await CorrectMedicalTermsUsingAI(inputToSave);
    if (result) {
      showSuccessToast("Updated General Notes");
      setAddGeneralAppointmentDieticianNotes(result?.text);
    }
  } catch (error) {
    console.error("Error in Correct cc ai call:", error);
    showErrorToast("Error in Correct AI call.");
  } finally {
    dismissLoader();
  }
};

const correctDieticianNotes = async (cc_text) => {
  console.log('cc_text: ', cc_text)
  const inputToSave = {
    input: {
      text: cc_text,
      type: "Dietician Notes",
//       type: `dietitian_notes
// #${doctorSpecialties}#${noteType}#${doctorExperience}#${inpLang}#${outLang}`,
    },
  };

  showLoader();
  try {
    const result = await CorrectMedicalTermsUsingAI(inputToSave);
    if (result) {
      showSuccessToast("Updated Dietician Notes");
      setAddAppointmentDieticianNotes(result?.text);
    }
  } catch (error) {
    console.error("Error in Correct dietician notes ai call:", error);
    showErrorToast("Error in Correct AI call.");
  } finally {
    dismissLoader();
  }
};

    return (
      <Box
        position="relative"
        height="100%"
        display="flex"
        flexDirection="column"
      >
        {isLoading && (
          <Box
            position="absolute"
            top="0"
            left="0"
            width="100%"
            height="100%"
            display="flex"
            alignItems="center"
            justifyContent="center"
            zIndex="10"
            bg="rgba(255, 255, 255, 0.8)"
          >
            <Loader miniLoader={true} />
          </Box>
        )}
        <Box bg="white">
          <Accordion
            allowMultiple
            index={expandedIndices}
            onChange={(indices) => setExpandedIndices(indices)}
          >
            <AccordionItem>
              <h2>
                <AccordionButton>
                  <Box flex="1" textAlign="left">
                    Prescription
                  </Box>
                  <>
                    {/* <Badge
                      onClick={() => fetchRecommendMedicines()}
                      cursor="pointer"
                      color="blue"
                      bg={"white"}
                      ml={2}
                      // {...(index === formInputs.length - 1
                      //   ? {}
                      //   : { display: "none" })}
                    >
                      AI Generate
                    </Badge> */}
                    <Badge
                      ml="1"
                      color="blue"
                      bg="white"
                      cursor="pointer"
                      onClick={handleAddPrescription}
                    >
                      {currentMedicationData.length > 0 ? "View" : "+ Add"}
                    </Badge>
                  </>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4} bg="#f9fafb">
                {/* Content for Prescription */}
                <Box>
                  <CurrentOrderMedications
                    medicines={currentMedicationData}
                    patientId={patientId}
                    patientname={patientname}
                    patientgender={patientgender}
                    patientage={patientage}
                    doctorId={doctorId}
                    appointmentId={appointmentId}
                    fetchDoctorNotes={fetchDoctorNotes}
                    showLoader={showSubLoader}
                    dismissLoader={dismissSubLoader}
                    showSuccessToast={showSuccessToast}
                    showErrorToast={showErrorToast}
                    fetchDoctorNotesEmptyIndication={
                      fetchDoctorNotesEmptyIndication
                    }
                    fetchPatientHealthData={fetchPatientHealthData}
                    ref={prescriptionComponentRef}
                  addPrescription={addPrescription}
                  />
                </Box>
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem>
              <h2>
                <AccordionButton>
                  <Box flex="1" textAlign="left">
                    Procedure
                  </Box>
                  <Badge
                    ml="1"
                    color="blue"
                    bg="white"
                    cursor="pointer"
                    onClick={handleAddProcedure}
                  >
                    + Add
                  </Badge>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4} bg="#f9fafb">
                {/* Content for Procedure */}
                <Box>
                  {currentProcedureData &&
                    currentProcedureData.map((procedureData, index) => (
                      <CurrentOrderView
                        key={index}
                        orderId={procedureData.orderid}
                        entityType={procedureData.entitytype}
                        orderName={procedureData.ordername}
                        orderDate={procedureData.orderdate}
                        createdBy={procedureData.createdby}
                        patientId={patientId}
                        doctorId={doctorId}
                        appointmentId={appointmentId}
                        fetchDoctorNotes={fetchDoctorNotes}
                        showLoader={showSubLoader}
                        dismissLoader={dismissSubLoader}
                        showSuccessToast={showSuccessToast}
                        showErrorToast={showErrorToast}
                        scaleHeight="70px"
                        fetchDoctorNotesEmptyIndication={
                          fetchDoctorNotesEmptyIndication
                        }
                      />
                    ))}
                </Box>
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem>
              <h2>
                <AccordionButton>
                  <Box flex="1" textAlign="left">
                    Labs
                  </Box>
                  <Badge
                    ml="1"
                    color="blue"
                    bg="white"
                    cursor="pointer"
                    onClick={handleAddLabs}
                  >
                    + Add
                  </Badge>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4} bg="#f9fafb">
                {/* Content for Labs */}
                <Box>
                  {currentLabData &&
                    currentLabData.map((labData, index) => (
                      <CurrentOrderView
                        key={index}
                        orderId={labData.orderid}
                        entityType={labData.entitytype}
                        orderName={labData.ordername}
                        orderDate={labData.orderdate}
                        createdBy={labData.createdby}
                        patientId={patientId}
                        doctorId={doctorId}
                        appointmentId={appointmentId}
                        fetchDoctorNotes={fetchDoctorNotes}
                        showLoader={showSubLoader}
                        dismissLoader={dismissSubLoader}
                        showSuccessToast={showSuccessToast}
                        showErrorToast={showErrorToast}
                        scaleHeight="70px"
                        fetchDoctorNotesEmptyIndication={
                          fetchDoctorNotesEmptyIndication
                        }
                      />
                    ))}
                </Box>
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem>
              <h2>
                <AccordionButton>
                  <Box flex="1" textAlign="left">
                    Imaging
                  </Box>
                  <Badge
                    ml="1"
                    color="blue"
                    bg="white"
                    cursor="pointer"
                    onClick={handleAddImaging}
                  >
                    + Add
                  </Badge>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4} bg="#f9fafb">
                <Box>
                  {currentImagingData &&
                    currentImagingData.map((imagingData, index) => (
                      <CurrentOrderView
                        key={index}
                        orderId={imagingData.orderid}
                        entityType={imagingData.entitytype}
                        orderName={imagingData.ordername}
                        orderDate={imagingData.orderdate}
                        createdBy={imagingData.createdby}
                        patientId={patientId}
                        doctorId={doctorId}
                        appointmentId={appointmentId}
                        fetchDoctorNotes={fetchDoctorNotes}
                        showLoader={showSubLoader}
                        dismissLoader={dismissSubLoader}
                        showSuccessToast={showSuccessToast}
                        showErrorToast={showErrorToast}
                        scaleHeight="70px"
                        fetchDoctorNotesEmptyIndication={
                          fetchDoctorNotesEmptyIndication
                        }
                      />
                    ))}
                </Box>
              </AccordionPanel>
            </AccordionItem>

            {/* Dietitian start */}
            <AccordionItem>
              <h2>
                <AccordionButton>
                  <Box flex="1" textAlign="left">
                    Dietician Notes
                  </Box>
                  <Badge
                    ml="1"
                    color="blue"
                    bg="white"
                    cursor="pointer"
                    // onClick={() => {
                    //   document.getElementById("dietician-notes").click();
                    // }}
                    onClick={() => {
                      if (dieticianNotesRef.current) {
                        dieticianNotesRef.current.click();
                      } else {
                        console.warn("Dietician notes element not found");
                        // showErrorToast("Dietician notes section not available");
                      }
                    }}
                  >
                    + Add
                  </Badge>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4} bg="#f9fafb">
                <Box display="flex" flexDir="column" gap="0.5rem">
                  {dieticianNotes &&
                    dieticianNotes.map((item, index) => (
                      <Box display="flex" w="100%" key={index}>
                        <Box
                          p="20px"
                          w="100%"
                          h="50px"
                          // ml={{base: 0, md: "10px"}}
                          display="flex"
                          flexDirection="row"
                          alignItems="center"
                          justifyContent="space-between"
                          border="1px solid #E6E7E9"
                          borderRadius="12px"
                          backgroundColor={"white"}
                        >
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            flex="1"
                            overflow="hidden"
                            alignItems="center"
                          >
                            <Text
                              title={item.dietnote}
                              fontSize="16px"
                              textAlign="left"
                              fontWeight="600"
                              whiteSpace="nowrap"
                              overflow="hidden"
                              textOverflow="ellipsis"
                              w="100%"
                            >
                              {item.dietnote}
                            </Text>
                          </Box>
                          <Box display="flex" ml="0.5rem" alignItems="center">
                            <Box
                              as="button"
                              border="1px solid #E6E7E9"
                              borderRadius="full"
                              w="36px"
                              h="auto"
                              p="10px"
                              onClick={() =>
                                openDieticianModal(
                                  item.id,
                                  "edit",
                                  item.dietnote
                                )
                              }
                            >
                              <Image
                                w="13px"
                                src="/assets/svgs/edit-gray.svg"
                              />
                            </Box>
                            <Box
                              as="button"
                              border="1px solid #E6E7E9"
                              borderRadius="full"
                              w="36px"
                              h="auto"
                              p="10px"
                              ml="10px"
                              onClick={() =>
                                openDieticianModal(item.id, "delete")
                              }
                            >
                              <Image w="13px" src="/assets/imgs/delete.png" />
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    ))}
                </Box>
                <Box mt="0.5rem" display="flex" pos='relative' flexDir="column" gap="1rem">
                  {/* <Textarea
                    id="dietician-notes"
                    placeholder="Add Dietician Note"
                    value={addAppointmentDieticianNotes}
                    onChange={(e) =>
                      setAddAppointmentDieticianNotes(e.target.value)
                    }
                  /> */}
                  <Textarea
                          borderRadius='0'
                      value={addAppointmentDieticianNotes}
            onChange={(e) => {
              setAddAppointmentDieticianNotes(e.target.value)
              // setValue('textField', e.target.value); 
            }}
                          height="100%"
                          padding="2"
                          resize="none"
                          style={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
                        />
                        {/* {!textFieldValue && ( */}
                          {!addAppointmentDieticianNotes && (
                          <Text
                            position="absolute"
                            bottom="50%"
                            left="50%"
                            transform="translateX(-50%)"
                            fontSize="sm"
                            color="gray.500"
                            w={{ base: "100%", md: "unset" }}
                            textAlign={{ base: "center", md: "unset" }}
                          >
                            {/* {placeholderDietician} */}
                            {typingDietician ? "Processing..." : placeholderDietician}
                          </Text>
                        )}

                  <Box mt="0.5rem" display="flex" flexDir="row" gap="1rem">
                    {/* <GPUChatAudioManager
                                transcriber={activeTranscriber}
                                setPlaceholder={setPlaceholder}
                                setTyping={setTyping}
                              />
                              <Box
                                as="button"
                                border="1px solid #E6E7E9"
                                borderRadius="full"
                                w="36px"
                                h="auto"
                                p="10px"
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                cursor={textFieldValue && isChatbotAllowed() ? "pointer" : "not-allowed"}
                                opacity={textFieldValue && isChatbotAllowed() ? 1 : 0.5}
                                pointerEvents={textFieldValue && isChatbotAllowed() ? "auto" : "none"}
                                onClick={() => 
                                  textFieldValue && isChatbotAllowed() && correctChiefComplaintDieticianNotes(textFieldValue)
                                }
                                bg={isChatbotAllowed() ? "transparent" : "gray.100"}
                                _hover={
                                  textFieldValue && isChatbotAllowed() 
                                    ? { bg: "gray.50", borderColor: "gray.300" } 
                                    : {}
                                }
                                title={
                                  !isChatbotAllowed() 
                                    ? "Please upgrade your subscription to use AI features"
                                    : !textFieldValue
                                    ? "Please enter text to enable AI suggestions"
                                    : "Get AI suggestions"
                                }
                              >
                                <Image 
                                  w="26px" 
                                  src="/assets/svgs/ai-star-outline.svg" 
                                  opacity={textFieldValue && isChatbotAllowed() ? 1 : 0.5}
                                  filter={!isChatbotAllowed() ? "grayscale(100%)" : "none"}
                                />
                              </Box> */}
                              <Box mt="0.5rem" display="flex" flexDir="row" gap="1rem" alignItems="center">
        {/* Add Recorder for Dietician Notes */}
        <GPUChatAudioManager
          transcriber={activeTranscriberDietician}
          setPlaceholder={setPlaceholderDietician}
          // setPlaceholder={setPlaceholder}
          setTyping={setTypingDietician}
          onTranscribedText={(text) => {
            setAddAppointmentDieticianNotes(text);
            // setValue("textField", text);
          }}
        />
        
        {/* Add Clutter button for Dietician Notes */}
        <Box
          as="button"
          border="1px solid #E6E7E9"
          borderRadius="full"
          w="36px"
          h="auto"
          p="10px"
          display="flex"
          justifyContent="center"
          alignItems="center"
          cursor={addAppointmentDieticianNotes && isChatbotAllowed() ? "pointer" : "not-allowed"}
          opacity={addAppointmentDieticianNotes && isChatbotAllowed() ? 1 : 0.5}
          pointerEvents={addAppointmentDieticianNotes && isChatbotAllowed() ? "auto" : "none"}
          onClick={() => 
            addAppointmentDieticianNotes && isChatbotAllowed() && correctDieticianNotes(addAppointmentDieticianNotes)
          }
          bg={isChatbotAllowed() ? "transparent" : "gray.100"}
          _hover={
            addAppointmentDieticianNotes && isChatbotAllowed() 
              ? { bg: "gray.50", borderColor: "gray.300" } 
              : {}
          }
          title={
            !isChatbotAllowed() 
              ? "Please upgrade your subscription to use AI features"
              : !addAppointmentDieticianNotes
              ? "Please enter text to enable AI suggestions"
              : "Get AI suggestions"
          }
        >
          <Image 
            w="26px" 
            src="/assets/svgs/ai-star-outline.svg" 
            opacity={addAppointmentDieticianNotes && isChatbotAllowed() ? 1 : 0.5}
            filter={!isChatbotAllowed() ? "grayscale(100%)" : "none"}
          />
        </Box>
      </Box>
                    {/* <Box
  as="button"
  border="1px solid #E6E7E9"
  borderRadius="full"
  w="36px"
  h="auto"
  p="10px"
  display="flex"
  justifyContent="center"
  alignItems="center"
  onClick={isChatbotAllowed() ? () => generateAIDietPlan() : null}
  cursor={isChatbotAllowed() ? "pointer" : "not-allowed"}
  opacity={isChatbotAllowed() ? 1 : 0.5}
  bg={isChatbotAllowed() ? "transparent" : "gray.100"}
  _hover={
    isChatbotAllowed() 
      ? { bg: "gray.50", borderColor: "gray.300" } 
      : {}
  }
  title={
    !isChatbotAllowed() 
      ? "Please upgrade your subscription to use AI features" 
      : "Get AI suggestions"
  }
>
  <Image 
    w="26px" 
    src="/assets/svgs/ai-star-outline.svg" 
    opacity={isChatbotAllowed() ? 1 : 0.5}
    filter={!isChatbotAllowed() ? "grayscale(100%)" : "none"}
  />
</Box> */}
                    {/* <Box
                      as="button"
                      // onClick={}
                      border="1px solid #E6E7E9"
                      borderRadius="full"
                      w="36px"
                      h="auto"
                      p="10px"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      cursor={"pointer"}
                      onClick={generateAIDietPlan}
                    >
                      <Image w="26px" src="/assets/svgs/ai-star-outline.svg" />
                    </Box> */}
                    <PrimaryButton
                      onClick={addDieticianNotes}
                      buttonText="Add Dietician Note"
                      isDisabled={false || !actionAccessMain(22)?.create}
                      variant="mdBtn"
                      btnStyle={{ w: "100%" }}
                    />
                  </Box>
                </Box>
              </AccordionPanel>
            </AccordionItem>
            {/* Dietitian end */}

            {/* General Dietitian start */}
            <AccordionItem>
              <h2>
                <AccordionButton>
                  <Box flex="1" textAlign="left">
                    General Notes
                  </Box>
                  <Badge
                    ml="1"
                    color="blue"
                    bg="white"
                    cursor="pointer"
                    onClick={() => {
                      if (generalNotesRef.current) {
                        generalNotesRef.current.click();
                      } else {
                        console.warn("General notes element not found");
                        // showErrorToast("Dietician notes section not available");
                      }
                    }}
                    // onClick={() => {
                    //   document.getElementById("general-notes").click();
                    //   // document.getElementById("general-notes").focus();
                    // }}
                  >
                    + Add
                  </Badge>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4} bg="#f9fafb">
                <Box display="flex" flexDir="column" gap="0.5rem">
                  {generalDieticianNotes &&
  generalDieticianNotes.map((item, index) => (
    <Box display="flex" w="100%" key={index} mb="1rem">
      <Box
        p="20px"
        w="100%"
        display="flex"
        flexDirection="column"
        border="1px solid #E6E7E9"
        borderRadius="12px"
        backgroundColor="white"
      >
        {/* Doctor info section */}
        <Box 
          display="flex" 
          justifyContent="space-between"
          alignItems="center"
          mb="0.5rem"
        >
          <Box>
            <Text fontSize="14px" fontWeight="600">
              {item.doctorname}
            </Text>
            <Text fontSize="12px" color="gray.500">
              {item.doctorqualification?.map(deg => deg.degreename).join(', ')}
            </Text>
          </Box>
          <Text fontSize="12px" color="gray.500">
            {new Date(item.createddate).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
              hour: '2-digit',
              minute: '2-digit'
            })}
          </Text>
        </Box>

        {/* Note content and actions */}
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            flex="1"
            overflow="hidden"
          >
            <Text
              title={item.generalnote}
              fontSize="16px"
              textAlign="left"
              fontWeight="600"
              whiteSpace="nowrap"
              overflow="hidden"
              textOverflow="ellipsis"
              w="100%"
            >
              {item.generalnote}
            </Text>
          </Box>
          <Box display="flex" alignItems="center" ml="10px">
            <Box
              as="button"
              border="1px solid #E6E7E9"
              borderRadius="full"
              w="36px"
              h="auto"
              p="10px"
              onClick={() =>
                openGeneralDieticianModal(
                  item.id,
                  "edit",
                  item.generalnote
                )
              }
            >
              <Image w="13px" src="/assets/svgs/edit-gray.svg" />
            </Box>
            <Box
              as="button"
              border="1px solid #E6E7E9"
              borderRadius="full"
              w="36px"
              h="auto"
              p="10px"
              ml="10px"
              onClick={() =>
                openGeneralDieticianModal(item.id, "delete")
              }
            >
              <Image w="13px" src="/assets/imgs/delete.png" />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  ))
}
                  {/* {generalDieticianNotes &&
                    generalDieticianNotes.map((item, index) => (
                      <Box display="flex" w="100%" key={index}>
                        <Box
                          p="20px"
                          w="100%"
                          h="50px"
                          display="flex"
                          flexDirection="row"
                          alignItems="center"
                          justifyContent="space-between"
                          border="1px solid #E6E7E9"
                          borderRadius="12px"
                          backgroundColor="white"
                        >
                          <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            flex="1" // Dynamically takes available space
                            overflow="hidden" // Ensures text and buttons don't overflow
                          >
                            <Text
                              title={item.generalnote}
                              fontSize="16px"
                              textAlign="left"
                              fontWeight="600"
                              whiteSpace="nowrap"
                              overflow="hidden"
                              textOverflow="ellipsis"
                              w="100%" // Ensures the text takes available space
                            >
                              {item.generalnote}
                            </Text>
                          </Box>
                          <Box display="flex" alignItems="center" ml="10px">
                            <Box
                              as="button"
                              border="1px solid #E6E7E9"
                              borderRadius="full"
                              w="36px"
                              h="auto"
                              p="10px"
                              onClick={() =>
                                openGeneralDieticianModal(
                                  item.id,
                                  "edit",
                                  item.generalnote
                                )
                              }
                            >
                              <Image
                                w="13px"
                                src="/assets/svgs/edit-gray.svg"
                              />
                            </Box>
                            <Box
                              as="button"
                              border="1px solid #E6E7E9"
                              borderRadius="full"
                              w="36px"
                              h="auto"
                              p="10px"
                              ml="10px"
                              onClick={() =>
                                openGeneralDieticianModal(item.id, "delete")
                              }
                            >
                              <Image w="13px" src="/assets/imgs/delete.png" />
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    ))} */}
                </Box>
                <Box mt="0.5rem" display="flex" flexDir="column" gap="1rem">
                  <Box
                      as="form"
                      width='100%'
                      bg="white"
                      pt={"2px"}
                    >
                      <Box flex="1" width="100%" position="relative" bg={"#f9fafb"}>
                        <Textarea
                          borderRadius='0'
                          // placeholder="Instructions"
                      //     {...register("textField")}
                      //     inputValue={addGeneralAppointmentDieticianNotes}
                      //     onChange={(e) => {
                      // setAddGeneralAppointmentDieticianNotes(e.target.value)
                      // setValue('textField', e.target.value); 
                      //     }}
                      value={addGeneralAppointmentDieticianNotes}
            onChange={(e) => {
              setAddGeneralAppointmentDieticianNotes(e.target.value)
              // setValue('textField', e.target.value); 
            }}
                          // onChange={(e) => handleNewMedicineChange("custommessage", e.target.value)}
                          height="100%"
                          padding="2"
                          resize="none"
                          // disabled={typing} // Disable when AI typing is true
                          style={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
                        />
                        {/* {!textFieldValue && ( */}
                        {!addGeneralAppointmentDieticianNotes && (
                          <Text
                            position="absolute"
                            bottom="2"
                            left="50%"
                            transform="translateX(-50%)"
                            fontSize="sm"
                            color="gray.500"
                            w={{ base: "100%", md: "unset" }}
                            textAlign={{ base: "center", md: "unset" }}
                          >
                            {/* {placeholderGeneral} */}
                            {typingGeneral ? "Processing..." : placeholderGeneral}
                          </Text>
                        )}
                      </Box>
                      
                    </Box>
                  {/* <Textarea
                    id="general-notes"
                    placeholder="Add General Notes"
                    value={addGeneralAppointmentDieticianNotes}
                    onChange={(e) =>
                      setAddGeneralAppointmentDieticianNotes(e.target.value)
                    }
                  /> */}
                  <Box mt="0.5rem" display="flex" flexDir="row" gap="1rem">

                  <GPUChatAudioManager
                                transcriber={activeTranscriberGeneral}
                                setPlaceholder={setPlaceholderGeneral}
                                setTyping={setTypingGeneral}
                                onTranscribedText={(text) => {
            setAddGeneralAppointmentDieticianNotes(text);
            // setValue("textField", text);
          }}
                              />
                              <Box
          as="button"
          border="1px solid #E6E7E9"
          borderRadius="full"
          w="36px"
          h="auto"
          p="10px"
          display="flex"
          justifyContent="center"
          alignItems="center"
          cursor={addGeneralAppointmentDieticianNotes && isChatbotAllowed() ? "pointer" : "not-allowed"}
          opacity={addGeneralAppointmentDieticianNotes && isChatbotAllowed() ? 1 : 0.5}
          pointerEvents={addGeneralAppointmentDieticianNotes && isChatbotAllowed() ? "auto" : "none"}
          onClick={() => 
            addGeneralAppointmentDieticianNotes && isChatbotAllowed() && correctChiefComplaint(addGeneralAppointmentDieticianNotes)
          }
          bg={isChatbotAllowed() ? "transparent" : "gray.100"}
          _hover={
            addGeneralAppointmentDieticianNotes && isChatbotAllowed() 
              ? { bg: "gray.50", borderColor: "gray.300" } 
              : {}
          }
          title={
            !isChatbotAllowed() 
              ? "Please upgrade your subscription to use AI features"
              : !addGeneralAppointmentDieticianNotes
              ? "Please enter text to enable AI suggestions"
              : "Get AI suggestions"
          }
        >
          <Image 
            w="26px" 
            src="/assets/svgs/ai-star-outline.svg" 
            opacity={addGeneralAppointmentDieticianNotes && isChatbotAllowed() ? 1 : 0.5}
            filter={!isChatbotAllowed() ? "grayscale(100%)" : "none"}
          />
        </Box>
                  <PrimaryButton
                    onClick={addGeneralDieticianNotes}
                    buttonText="Add General Notes"
                    isDisabled={false || !actionAccessMain(22)?.create}
                    variant="mdBtn"
                    btnStyle={{ w: "100%" }}
                  />
                </Box>
                </Box>
              </AccordionPanel>
            </AccordionItem>
            {/* General Dietitian end */}

            {/* Vaccination start */}
            <AccordionItem>
              <h2>
                <AccordionButton>
                  <Box flex="1" textAlign="left">
                    Vaccinations
                  </Box>
                  <Badge
                    ml="1"
                    color="blue"
                    bg="white"
                    cursor="pointer"
                    onClick={handleAddVaccinations}
                  >
                    + Add
                  </Badge>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4} bg="#f9fafb">
                {/* Content for Vaccinations */}
                <Box>
                  {currentVaccinationData &&
                    currentVaccinationData.map((vaccinationData, index) => (
                      <CurrentOrderView
                        key={index}
                        orderId={vaccinationData.id}
                        // entityType={vaccinationData.entitytype}
                        entityType='vaccination'
                        orderName={vaccinationData.vaccinename}
                        applyDate={vaccinationData.admindate}
                        dueDate={vaccinationData.duedate}
                        orderDate={vaccinationData.orderdate}
                        createdBy={vaccinationData.createdby}
                        patientId={patientId}
                        doctorId={doctorId}
                        appointmentId={appointmentId}
                        fetchDoctorNotes={fetchDoctorNotes}
                        showLoader={showSubLoader}
                        dismissLoader={dismissSubLoader}
                        showSuccessToast={showSuccessToast}
                        showErrorToast={showErrorToast}
                        scaleHeight="70px"
                        fetchDoctorNotesEmptyIndication={
                          fetchDoctorNotesEmptyIndication
                        }
                      />
                    ))}
                </Box>
              </AccordionPanel>
            </AccordionItem>
            {/* Vaccination end */}
          </Accordion>

          {/* Modal To ADD orders - procedures, labs and imaging  */}
          <ModalRight
            ref={addOrder}
            header={`Add ${currentOrderType}`}
            body={
              <>
                <Box display="flex" flexDir="column" gap="20px">
                  <PrimaryButton
                    buttonText={`Search ${currentOrderType}`}
                    variant="grayBtn"
                    btnStyle={{ w: "100%", color: COLORS.PRIMARY_COLOR }}
                    // isDisabled={isSaveButtonDisabled}
                    onClick={() =>
                      openSpecificSearchOrderOverlay(currentOrderType)
                    }
                  />

                  {orderInputFields.map((field, index) => (
                    <Box
                      key={field.id}
                      display="flex"
                      alignItems="center"
                      gap="10px"
                    >
                      <PrimaryInput
                        variant="bothSide"
                        inputType="text"
                        inputPlace={`${currentOrderType} name`}
                        onChange={(event) =>
                          handleAddOrderName(field.id, event.target.value)
                        }
                      />
                      <Box
                        as="button"
                        border="1px solid #E6E7E9"
                        borderRadius="full"
                        w="36px"
                        h="36px"
                        p="10px"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        onClick={() => deleteOrderInputField(field.id)}
                      >
                        <Image w="13px" src="/assets/imgs/delete.png" />
                      </Box>
                      {/* {index < orderInputFields.length - 1 && (
                        <Divider marginTop="20px" />
                      )} */}
                    </Box>
                  ))}
                  <Divider />
                  <Box marginTop="12px" textAlign="left">
                    <Button
                      onClick={addOrderInputField}
                      bg="#fcfcfd"
                      color="blue"
                      w="90%" // Make the button full width
                      textAlign="left" // Align the text to the left
                    >
                      {`+ Add ${currentOrderType}`}
                    </Button>
                  </Box>
                </Box>
              </>
            }
            footerActions={
              <>
                <Box w="100%" display="flex" flexDirection="row" gap="15px">
                  <PrimaryButton
                    buttonText={`Save ${currentOrderType}`}
                    isDisabled={
                      isSaveButtonDisabled || !actionAccessMain(22)?.create
                    }
                    onClick={AddOrder}
                  />
                </Box>
              </>
            }
          />

          {/* Modal To ADD Orders Via Common Search  */}
          <ModalRight
            ref={openSearch}
            modalWidth={"25%"}
            header={"Search"}
            body={
              <>
                <SearchBar
                  passInputPlace="Search"
                  onChange={(e) => setSearchValue(e.target.value)}
                />
                <RadioGroup>
                  <Stack direction="column" gap="0">
                    {searchMasterData
                      .filter((item) =>
                        item.subtype
                          .toLowerCase()
                          .includes(searchValue.toLowerCase())
                      )
                      .map((item) => (
                        <label key={item.id}>
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            borderBottom="1px solid #e2e8f0"
                            p="15px"
                            pl="5px"
                            minH="50px"
                            width="100%"
                            sx={{
                              _hover: {
                                border: "2px solid #384052",
                                borderRadius: "10px",
                              },
                            }}
                          >
                            <Box display="flex" alignItems="center">
                              <Text
                                fontSize="16px"
                                lineHeight="normal"
                                fontWeight="600"
                              >
                                {`${
                                  item.category.charAt(0).toUpperCase() +
                                  item.category.slice(1)
                                }: ${item.subtype}`}
                              </Text>
                            </Box>
                            <Box display="flex" justifyContent="end">
                              <Checkbox
                                colorScheme="green"
                                sx={{
                                  ".chakra-checkbox__control": {
                                    width: "20px",
                                    height: "20px",
                                    borderRadius: "5px",
                                  },
                                }}
                                onChange={() => handleCheckboxChange(item)}
                                isChecked={isChecked(item.id)}
                              ></Checkbox>
                            </Box>
                          </Box>
                        </label>
                      ))}
                    {searchMasterData.every(
                      (item) =>
                        !item.subtype
                          .toLowerCase()
                          .includes(searchValue.toLowerCase())
                    ) && (
                      <Box
                        p="15px"
                        fontSize="16px"
                        fontWeight="600"
                        textAlign="center"
                      >
                        No matching results found!
                      </Box>
                    )}
                  </Stack>
                </RadioGroup>
              </>
            }
            footerActions={
              <>
                <Box w="100%" display="flex" flexDirection="row">
                  <PrimaryButton
                    buttonText={"Save To Orders"}
                    // isDisabled={false}
          isDisabled={false || !actionAccessMain(22)?.create}

                    onClick={handleSearchSaveButtonClick}
                  />
                </Box>
              </>
            }
          />

          {/* 2nd Modal To Search Specific Order  */}
          <ModalRight
            ref={openSearchSpecificOrder}
            // modalWidth={"25%"}
            header={"Search"}
            body={
              <>
                <SearchBar
                  passInputPlace="Search"
                  onChange={(e) => setSearchValue(e.target.value)}
                />
                <RadioGroup>
                  <Stack direction="column" gap="0">
                    {specificSearchOrderData
                      .filter((item) =>
                        item.subtype
                          .toLowerCase()
                          .includes(searchValue.toLowerCase())
                      )
                      .map((item) => (
                        <label key={item.id}>
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            borderBottom="1px solid #e2e8f0"
                            p="15px"
                            pl="5px"
                            minH="50px"
                            width="100%"
                            sx={{
                              _hover: {
                                border: "2px solid #384052",
                                borderRadius: "10px",
                              },
                            }}
                          >
                            <Box display="flex" alignItems="center">
                              <Text
                                fontSize="16px"
                                lineHeight="normal"
                                fontWeight="600"
                              >
                                {`${
                                  item.category.charAt(0).toUpperCase() +
                                  item.category.slice(1)
                                }: ${item.subtype}`}
                              </Text>
                            </Box>
                            <Box display="flex" justifyContent="end">
                              <Checkbox
                                colorScheme="green"
                                sx={{
                                  ".chakra-checkbox__control": {
                                    width: "20px",
                                    height: "20px",
                                    borderRadius: "5px",
                                  },
                                }}
                                onChange={() => handleCheckboxChange(item)}
                                isChecked={isChecked(item.id)}
                              ></Checkbox>
                            </Box>
                          </Box>
                        </label>
                      ))}
                    {specificSearchOrderData.every(
                      (item) =>
                        !item.subtype
                          .toLowerCase()
                          .includes(searchValue.toLowerCase())
                    ) && (
                      <Box
                        p="15px"
                        fontSize="16px"
                        fontWeight="600"
                        textAlign="center"
                      >
                        No matching results found!
                      </Box>
                    )}
                  </Stack>
                </RadioGroup>
              </>
            }
            footerActions={
              <>
                <Box w="100%" display="flex" flexDirection="row">
                  <PrimaryButton
                    buttonText={"Save To Orders"}
                    // isDisabled={false}
                    isDisabled={false || !actionAccessMain(22)?.create}
                    onClick={handleSpecificOrderSearchSaveButtonClick}
                  />
                </Box>
              </>
            }
          />

          {/* Modal To ADD Prescription  */}
          <ModalRight
  ref={addPrescription}
  closeAction={() => dynamicModalPrescriptionDiscard.current.openModal()}
  modalWidth={"100%"}
//   header={
//     <>
//     <Box display='flex' alignItems='center' gap='2rem'>
//       <Text fontWeight='600'>Add Medication</Text>
//       <Box display="flex" flexDirection="column" gap="0.5rem">
//   {/* Row 1: Patient Info */}
//   <Box display="flex" gap="0.5rem" alignItems="center">
//     {patientFullInfo?.patientimage ? (
//       <Image
//         borderRadius="full"
//         w="2.75rem"
//         h="2.75rem"
//         src={`${patientFullInfo?.imagepath || ''}${patientFullInfo.patientimage}`}
//         alt="Patient"
//       />
//     ) : (
//       <Image
//         borderRadius="full"
//         w="2.75rem"
//         h="2.75rem"
//         src="/assets/imgs/no-image.png"
//         alt="No patient image"
//       />
//     )}
//     <Box>
//       <Text fontSize="1rem" fontWeight="600" color="black">
//         {patientname}
//       </Text>
//       <Box display="flex" gap="2rem" alignItems="center" flexWrap="wrap">
//         <Text fontSize="0.75rem" fontWeight="500" color="#384052">
//           {navHeaderOverviewData}
//         </Text>
//         {/* Dx and Vitals */}
//     <Box display="flex" flexWrap="wrap" gap="1rem" fontSize="0.75rem" alignItems="center">
//       {/* Vitals */}
//       {patientHealthData?.vitals && (
//         <>
//           <Box display="flex" alignItems="center">
//             <Text fontWeight="600" title="Blood Pressure">BP:</Text>
//             <Text ml="0.25rem">
//               {patientHealthData.vitals.find(v => v?.vitalName === "BP")?.vitalValue || '-'}
//             </Text>
//           </Box>
//           <Box display="flex" alignItems="center">
//             <Text fontWeight="600" title="Heart Rate">HR:</Text>
//             <Text ml="0.25rem">
//               {patientHealthData.vitals.find(v => v?.vitalName === "Heart rate")?.vitalValue || '-'} bpm
//             </Text>
//           </Box>
//           <Box display="flex" alignItems="center">
//             <Text fontWeight="600" title="Respiratory Rate">RR:</Text>
//             <Text ml="0.25rem">
//               {patientHealthData.vitals.find(v => v?.vitalName === "Respiratory")?.vitalValue || '-'} bpm
//             </Text>
//           </Box>
//           <Box display="flex" alignItems="center">
//             <Text fontWeight="600" title="Body Temperature">Temp:</Text>
//             <Text ml="0.25rem">
//               {patientHealthData.vitals.find(v => v?.vitalName === "Body temperature")?.vitalValue || '-'}°F
//             </Text>
//           </Box>
//           <Box display="flex" alignItems="center">
//             <Text fontWeight="600" title="Oxygen">SpO₂:</Text>
//             <Text ml="0.25rem">
//               {patientHealthData.vitals.find(v => v?.vitalName === "SPO2")?.vitalValue || '-'}%
//             </Text>
//           </Box>
//         </>
//       )}

//       {/* Diagnosis */}
//       {patientHealthData?.doctorsassessment?.[0]?.diagnosis && (
//         <Box display="flex" alignItems="center">
//           <Text fontWeight="600">Diagnosis:</Text>
//           <Text ml="0.25rem">
//             {patientHealthData.doctorsassessment[0].diagnosis || '-'}
//           </Text>
//         </Box>
//       )}
//     </Box>
//       </Box>
//     </Box>
//   </Box>

//   {/* Row 2: Medical Details */}
//   <Box display="flex" flexDirection="column" gap="0.25rem">
//     {/* CC and HPI in first line */}
//     <Box display="flex" flexWrap="wrap" gap="1rem" fontSize="0.75rem" alignItems="center">
//       {/* Chief Complaint */}
//       {/* {patientHealthData?.historyofpresentillness?.[0]?.details && (
//         <Box display="flex" alignItems="center">
//           <Text fontWeight="600">CC:</Text>
//           <Text ml="0.25rem">
//             {patientHealthData.historyofpresentillness[0].details
//               .find(d => d?.attribute === "Site")?.values?.[0]?.value || '-'} pain
//             {patientHealthData.historyofpresentillness[0].details
//               .find(d => d?.attribute === "Rating Scale")?.value 
//               ? ` (${patientHealthData.historyofpresentillness[0].details
//                   .find(d => d?.attribute === "Rating Scale")?.value}/10)` 
//               : ''}
//           </Text>
//         </Box>
//       )} */}

//       <Box display="flex" alignItems="center">
//         <Text fontWeight="600">CC:</Text>
//         <Text ml="0.25rem">
//           {currentCCData ? currentCCData : "-"}
//         </Text>  
//       </Box>

      
//       {/* HPI */}
//       {patientHealthData?.historyofpresentillness?.[0] && (
//         <Box display="flex" alignItems="center">
//           <Text fontWeight="600">HPI:</Text>
//           <Text ml="0.25rem" fontStyle="italic">
//             {generateDynamicText(
//               patientHealthData.historyofpresentillness[0],
//               patientFullInfo?.gender,
//               patientFullInfo?.dob
//             )?.[0] || '-'}
//           </Text>
//         </Box>
//       )}
//     </Box>
//   </Box>
// </Box>
//     </Box>
//     </>
//   }

header={
  <>
  <Box display='flex' gap='2rem' alignItems='flex-start'>
      {/* <Text fontWeight='600' fontSize='1.25rem'>Add Medication</Text> */}
    <Box display='flex' alignItems='flex-start' gap='0.25rem' flexDirection='column'>
      
      {/* Patient Info Row */}
      <Box display="flex" gap="0.25rem" alignItems="center">
  {/* Patient Image */}
  {patientFullInfo?.patientimage ? (
    <Image
      borderRadius="full"
      w="2.75rem"
      h="2.75rem"
      src={`${patientFullInfo?.imagepath || ''}${patientFullInfo.patientimage}`}
      alt="Patient"
    />
  ) : (
    <Image
      borderRadius="full"
      w="2.75rem"
      h="2.75rem"
      src="/assets/imgs/no-image.png"
      alt="No patient image"
    />
  )}

  {/* Patient Details */}
  <Box ml="0.75rem">
    <Text fontSize="1rem" fontWeight="600" color="black">
      {patientname}
    </Text>
    <Text fontSize="0.75rem" fontWeight="500" color="#384052">
      {navHeaderOverviewData}
    </Text>
  </Box>

  {/* Vitals Section */}
  <Box 
    display="flex" 
    // flexDirection="column" 
    ml="1rem" 
    // pl="1rem" 
    borderLeft="1px solid #e2e2e2"
    justifyContent="center"
  >
    {/* Vitals Title Box - Centered across both lines */}
    <Box 
      display="flex" 
      alignItems="center" 
      justifyContent="center"
      mb="0.25rem"
      mr='0.5rem'
    >
      <Text 
        fontSize="0.875rem" 
        fontWeight="700" 
        color="#384052"
        // bg="#f0f4f8"
        px="0.75rem"
        py="0.25rem"
        borderRadius="4px"
      >
        VITALS
      </Text>
    </Box>

    {/* Vitals Content - Two Lines */}
    {navBarData?.vitals && (
  <Box display="flex" flexDirection="column" gap="0.25rem">
    {/* First Line - Main Vitals */}
    <Box display="flex" flexWrap="wrap" gap="1rem" alignItems="center" justifyContent="center">
      {(() => {
        const systolic = navBarData.vitals.find(v => v.vitalname === "Systolic Blood Pressure")?.vitalvalue;
        const diastolic = navBarData.vitals.find(v => v.vitalname === "Diastolic Blood Pressure")?.vitalvalue;
        
        return (
          <>
            {/* Main vitals except sugar and BP */}
            {navBarData.vitals
              .filter(vital =>
                !vital.vitalname.includes("Fasting Blood Glucose") &&
                !vital.vitalname.includes("Postprandial Blood Glucose") &&
                vital.vitalname !== "Systolic Blood Pressure" &&
                vital.vitalname !== "Diastolic Blood Pressure" &&
                vital.vitalname !== "Height" &&
                vital.vitalname !== "Weight"
              )
              .map((vital, index) => (
                <Box key={index} display="flex" alignItems="center" gap="0.25rem">
                  <Text fontWeight="600" fontSize="0.75rem">
                    {vitalNameShortMap[vital.vitalname] || vital.vitalname}:
                  </Text>
                  <Text fontSize="0.75rem">
                    {vital.vitalvalue} {vital.vitalunit}
                  </Text>
                </Box>
              ))}

            {/* Blood Pressure */}
            {(systolic && diastolic) && (
              <Box display="flex" alignItems="center" gap="0.25rem">
                <Text fontWeight="600" fontSize="0.75rem">Bp:</Text>
                <Text fontSize="0.75rem">{systolic}/{diastolic}</Text>
              </Box>
            )}
          </>
        );
      })()}
    </Box>

    {/* Second Line - Sugar Readings */}
    <Box display="flex" flexWrap="wrap" gap="1rem" alignItems="center" justifyContent="flex-start">
      {navBarData.vitals
        .filter(vital => 
          vital.vitalname.includes("Fasting Blood Glucose") || 
          vital.vitalname.includes("Postprandial Blood Glucose")
        )
        .map((vital, index) => (
          <Box key={index} display="flex" alignItems="center" gap="0.25rem">
            <Text fontWeight="600" fontSize="0.75rem">
              {vitalNameShortMap[vital.vitalname] || 
               (vital.vitalname === "Postprandial Blood Glucose" ? "Post-Prandial Sugar" : vital.vitalname)}:
            </Text>
            <Text fontSize="0.75rem">
              {vital.vitalvalue} {vital.vitalunit}
            </Text>
          </Box>
        ))}
    </Box>
  </Box>
)}
  </Box>
</Box>

      {/* CC, HPI & Diagnosis Row */}
<Box display="flex" flexDirection="column" gap="0.25rem" width="100%">
  <Box display="flex" flexWrap="wrap" fontSize="0.75rem" alignItems="flex-start">
    {/* Chief Complaint */}
    <Box display="flex" flexShrink={0} alignItems="flex-start">
      <Text fontWeight="600">CC:</Text>
      <Text ml="0.25rem" whiteSpace="pre-wrap">
        {currentCCData || '-'}
      </Text>  
    </Box>
    
    {/* HPI with left border separator */}
    {navBarData?.historyofpresentillness?.length > 0  ? (
      <Box 
        display="flex" 
        alignItems="flex-start" 
        borderLeft="1px solid #e2e2e2" 
        ml="1rem" 
        pl="1rem"
        flex={1}
        minWidth="50%"
      >
        <Text fontWeight="600">HPI:</Text>
        <Text ml="0.25rem" fontStyle="italic" whiteSpace="pre-wrap">
          {generateDynamicText(
            navBarData.historyofpresentillness[0],
            patientFullInfo?.gender,
            patientFullInfo?.dob
          )?.[0] || '-'}
        </Text>
      </Box>
    ) : (
      <Box 
        display="flex" 
        alignItems="flex-start" 
        borderLeft="1px solid #e2e2e2" 
        ml="1rem" 
        pl="1rem"
        flex={1}
        minWidth="50%"
      >
        <Text fontWeight="600">HPI:</Text>
        <Text ml="0.25rem" fontStyle="italic" whiteSpace="pre-wrap">
          { navBarData.hpitext?.description ? navBarData.hpitext?.description : "-"}
        </Text>
      </Box>

    )}
  </Box>

  {/* Second Line: Diagnosis (only if exists) */}
  {navBarData?.doctorsassessment?.length > 0 && (
  <Box display="flex" fontSize="0.75rem" alignItems="center" mt="0.25rem">
    <Text fontWeight="600">Diagnosis:</Text>
    <Text ml="0.25rem">
      {navBarData.doctorsassessment
        .map(item => item.diagnosis)
        .filter(Boolean) // removes null/undefined/empty strings
        .join(', ') || '-'}
    </Text>
  </Box>
)}
  {/* {navBarData?.doctorsassessment?.[0]?.diagnosis && (
    <Box display="flex" fontSize="0.75rem" alignItems="center" mt="0.25rem">
      <Text fontWeight="600">Diagnosis:</Text>
      <Text ml="0.25rem">
        {navBarData.doctorsassessment[0].diagnosis || '-'}
      </Text>
    </Box>
  )} */}
</Box>
    </Box>
  </Box>
  </>
}
  bodyStyle={{ p: { base: "12px" } }}
  body={
    <>
      <PrescriptionComponent
        patientId={patientId}
        patientname={patientname}
        patientgender={patientgender}
        patientage={patientage}
        doctorId={doctorId}
        appointmentId={appointmentId}
        showSuccessToast={showSuccessToast}
        showErrorToast={showErrorToast}
        fetchDoctorNotes={fetchDoctorNotes}
        ref={prescriptionComponentRef}
        addPrescription={addPrescription}
        fetchPatientHealthData={fetchPatientHealthData}
        specialities={fetchedDoctorSpeciality}
        experience={fetchedDoctorExperience}
      />
    </>
  }
  footerActions={
    <>
      <Box
        w={{ base: "100%", lg: "20%" }}
        display="flex"
        flexDirection="row"
        gap="15px"
      >
        <PrimaryButton
          buttonText={`Save Prescription`}
          isDisabled={false || !actionAccessMain(22)?.create}
          onClick={handleSaveButtonClick}
        />
      </Box>
    </>
  }
/>

          {/* DynamicModal for Close Prescription */}
          <DynamicModal
            ref={dynamicModalPrescriptionDiscard}
            modalHeader={`Discard Changes?`}
            modalBody={
              <>
                <Text fontSize="14px" fontWeight="600">
                  Are you sure you want to discard these medications? Click
                  "Save & Exit" to save your changes before exiting.
                </Text>
              </>
            }
            modalFooterBtn={
              <>
                <PrimaryButton
                  buttonText="Save & Exit"
                  variant="grayBtn"
                  btnStyle={{
                    w: "45%",
                    color: COLORS.PRIMARY_COLOR,
                    h: "2.5rem",
                  }}
                  onClick={() => {
                    handleSaveButtonClick();
                    dynamicModalPrescriptionDiscard.current.closeModal();
                  }}
                />
                <Spacer />
                <PrimaryButton
                  variant="deleteBtn"
                  buttonText="Discard"
                  btnStyle={{
                    w: "45%",
                    h: "2.5rem",
                  }}
                  onClick={() => {
                    addPrescription.current.closeRight();
                    dynamicModalPrescriptionDiscard.current.closeModal();
                  }} // Close Prescriptions Modal and this modal
                />
              </>
            }
          />
        </Box>
        {/* Delete dietician notes */}
        <DynamicModal
          ref={deleteDieticianNotesModal}
          modalHeader={`Delete Dietician Notes?`}
          modalBody={
            <>
              <Text fontSize="14px" fontWeight="600">
                Are you sure you want to Delete Dietician Notes
              </Text>
            </>
          }
          modalFooterBtn={
            <>
              <PrimaryButton
                variant="deleteBtn"
                buttonText="Delete"
                btnStyle={{
                  w: "100%",
                  h: "2.5rem",
                }}
                isDisabled={false || !actionAccessMain(22)?.create}
                onClick={() => {
                  deleteDieticianNote();
                  deleteDieticianNotesModal.current.closeModal();
                }}
              />
            </>
          }
        />

        {/* Update dietician notes */}
        <DynamicModal
          ref={editDieticianNotesModal}
          modalHeader={`Update Dietician Notes`}
          modalBody={
            <>
              <Textarea
                placeholder="Update Dietitian Note"
                defaultValue={updateDieticianNotes}
                onChange={(e) =>
                  setAddAppointmentDieticianNotes(e.target.value)
                }
              />
            </>
          }
          modalFooterBtn={
            <>
              <PrimaryButton
                // variant="deleteBtn"
                buttonText="Update dietician notes"
                btnStyle={{
                  w: "100%",
                  h: "2.5rem",
                }}
                isDisabled={false || !actionAccessMain(22)?.create}
                onClick={() => {
                  editDieticianNotes();
                  editDieticianNotesModal.current.closeModal();
                }}
              />
            </>
          }
        />

        {/* Delete general dietician notes */}
        <DynamicModal
          ref={deleteGeneralDieticianNotesModal}
          modalHeader={`Delete Dietician Notes?`}
          modalBody={
            <>
              <Text fontSize="14px" fontWeight="600">
                Are you sure you want to Delete General Dietician Notes
              </Text>
            </>
          }
          modalFooterBtn={
            <>
              <PrimaryButton
                variant="deleteBtn"
                buttonText="Delete"
                btnStyle={{
                  w: "100%",
                  h: "2.5rem",
                }}
                onClick={() => {
                  deleteGeneralDieticianNote();
                  deleteGeneralDieticianNotesModal.current.closeModal();
                }}
              />
            </>
          }
        />

        {/* Update general dietician notes */}
        <DynamicModal
          ref={editGeneralDieticianNotesModal}
          modalHeader={`Update General Notes`}
          modalBody={
            <>
              <Textarea
                placeholder="Update General Note"
                defaultValue={updateGeneralDieticianNotes}
                onChange={(e) =>
                  setAddGeneralAppointmentDieticianNotes(e.target.value)
                }
              />
            </>
          }
          modalFooterBtn={
            <>
              <PrimaryButton
                // variant="deleteBtn"
                buttonText="Update general notes"
                btnStyle={{
                  w: "100%",
                  h: "2.5rem",
                }}
                isDisabled={false || !actionAccessMain(22)?.create}
                onClick={() => {
                  editGeneralDieticianNotes();
                  editGeneralDieticianNotesModal.current.closeModal();
                }}
              />
            </>
          }
        />

        <AiModal
          ref={AIChatModel}
          modalSize="420px"
          //icon="/assets/imgs/ai-doctor.png"
          header={
            <>
              <Box display="flex" flexDir="column">
                <Text
                  fontSize="1rem"
                  fontWeight="700"
                  backgroundImage="linear-gradient(to right top, #0d7e54, #007774, #006d94, #005ea7, #1146a0)"
                  color="transparent"
                  backgroundClip="text"
                >
                  Aira - AI
                </Text>
                <Text fontSize="0.75rem" fontWeight="400">
                  Chat with your AI health guide
                </Text>
              </Box>
            </>
          }
          headerStyle={{ p: "24px 32px", lineHeight: "normal" }}
          closeBtnStyle={{ top: "18px" }}
          footerStyle={{
            maxH: "35%",
            overflow: "hidden auto",
            boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
          }}
          withoutBg={true}
          backDropBlur="10px"
          body={
            <>
              <Flex flexDirection="column" height="100%">
                <Box
                  p="24px 32px"
                  ref={chatContainerRef}
                  className="chat-container"
                  style={{
                    overflowY: "auto",
                    maxHeight: "calc(100vh - 160px)",
                  }}
                >
                  {initialRender && remainingquestions.length > 0 && (
                    <Box>

                      {remainingquestions.map((step, index) => (
  <Box
    key={index}
    as="button"
    w="100%"
    p="16px"
    mb="16px"
    fontSize="14px"
    fontWeight="600"
    display="flex"
    flexDirection="row"
    alignItems="center"
    justifyContent="space-between"
    borderRadius="10px"
    border={isChatbotAllowed() ? "1px solid #7795DC" : "1px solid #CCCCCC"}
    bg={isChatbotAllowed() ? "#EAEDF5" : "#F5F5F5"}
    color={isChatbotAllowed() ? "#163E9E" : "#888888"}
    onClick={() => {
      if (isChatbotAllowed()) {
        GetAIAnswer(step.value);
      } else {
        showErrorToast("Please upgrade your subscription to use AI features");
      }
    }}
    className={`question-box ${animate ? "slide-in" : ""}`}
    cursor={isChatbotAllowed() ? "pointer" : "not-allowed"}
    opacity={isChatbotAllowed() ? 1 : 0.7}
    title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
  >
    {step.value ? step.value : "-"}
    <Image 
      src="/assets/imgs/right-icon.png" 
      opacity={isChatbotAllowed() ? 1 : 0.5}
      filter={!isChatbotAllowed() ? "grayscale(100%)" : "none"}
    />
  </Box>
))}
{/* dont delete this */}
                      {/* {remainingquestions.map((step, index) => (
                        <Box
                          key={index}
                          as="button"
                          w="100%"
                          p="16px"
                          mb="16px"
                          fontSize="14px"
                          fontWeight="600"
                          display="flex"
                          flexDirection="row"
                          alignItems="center"
                          justifyContent="space-between"
                          borderRadius="10px"
                          border="1px solid #7795DC"
                          bg="#EAEDF5"
                          color="#163E9E"
                          onClick={() => GetAIAnswer(step.value)}
                          className={`question-box ${
                            animate ? "slide-in" : ""
                          }`}
                        >
                          {step.value ? step.value : "-"}
                          <Image src="/assets/imgs/right-icon.png" />
                        </Box>
                      ))} */}
                    </Box>
                  )}
                  {aianswers.map((step, index) => (
                    <React.Fragment key={index}>
                      <Box
                        as="div"
                        bg="#061027"
                        p="12px 16px"
                        w="fit-content"
                        float="right"
                        borderRadius="10px 10px 1px 10px"
                        className={`answer-box ${animate ? "slide-in" : ""}`}
                      >
                        <Text fontSize="14px" fontWeight="500" color="white">
                          {step.question ? step.question : "-"}
                        </Text>
                      </Box>

                      <Box
                        as="div"
                        my="20px"
                        w="fit-content"
                        display="flex"
                        alignItems="end"
                        float="left"
                        className={`answer-box ${animate ? "slide-in" : ""}`}
                      >
                        <Image
                          bg="#061027"
                          p="4px"
                          mr="8px"
                          borderRadius="6px"
                          src="/assets/imgs/ai-chat-logo.png"
                        />
                        <Text
                          bg="#E6E7E980"
                          p="12px 16px"
                          fontSize="14px"
                          fontWeight="500"
                          color="#061027"
                          borderRadius="10px 10px 10px 1px"
                        >
                          {step.answer ? step.answer : <TypingLoader />}
                        </Text>
                      </Box>
                    </React.Fragment>
                  ))}
                </Box>
              </Flex>
            </>
          }
          footerActions={
            !initialRender && (
              <Box
                p="24px 32px"
                display="flex"
                w="100%"
                h="100%"
                flexDirection="column"
                justifyContent="space-between"
              >
                <Box w="100%">
                  {remainingquestions.map((step, index) => (
                    <Box
                      key={index}
                      as="button"
                      w="100%"
                      p="16px"
                      mb="16px"
                      fontSize="14px"
                      fontWeight="600"
                      display="flex"
                      flexDirection="row"
                      alignItems="center"
                      justifyContent="space-between"
                      borderRadius="10px"
                      border="1px solid #7795DC"
                      bg="#EAEDF5"
                      color="#163E9E"
                      onClick={() => GetAIAnswer(step.value)}
                      className={`question-box ${animate ? "slide-in" : ""}`}
                    >
                      {step.value ? step.value : "-"}
                      <Image src="/assets/imgs/right-icon.png" />
                    </Box>
                  ))}
                </Box>
              </Box>
            )
          }
        />

        {/* DynamicModal for Recommended Prescription */}
        <DynamicModalForTwo
          ref={aiRecommendMedicineRef}
          modalWidth="75%"
          modalHeader={`Aira - AI: Recommended Prescription`}
          modalBody={
            <>
              {recommendMedicinesAiResponse.map((medicine, index) => (
                <Box key={medicine.id}>
                  <Box
                    p="10px"
                    border="1px solid gray"
                    borderRadius="10px"
                    mt="10px"
                  >
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      // p="10px"
                      // border="1px solid gray"
                      // borderRadius="10px"
                      // mt="10px"
                    >
                      <Checkbox
                        isChecked={selectedRecommendedMedicinesAiResponses.includes(
                          index
                        )}
                        onChange={() =>
                          handleRecommendedMedicinesCheckboxChange(index)
                        }
                        mr={4}
                        alignSelf="center" // Vertically center the checkbox
                      ></Checkbox>
                      <Box width="42%">
                        <Box fontWeight={"semibold"}>
                          {medicine.medicinename}
                          <Box
                            display="inline-block"
                            verticalAlign="bottom"
                            fontSize="10px"
                            fontWeight="600"
                            bg="#E6E7E966"
                            border="1px solid #E6E7E9"
                            p="5px 10px"
                            borderRadius="full"
                            w="fit-content"
                            whiteSpace="nowrap"
                            overflow="hidden"
                            textOverflow="ellipsis"
                          >
                            {medicine.medicinetype
                              ? medicine.medicinetype
                              : "-"}
                            {/* Tablet */}
                          </Box>
                        </Box>
                        <Box fontSize={"xs"}>
                          Composition: {medicine.composition}
                        </Box>
                      </Box>
                      <Box width="8%">
                        {medicine.morning}-{medicine.evening}-{medicine.night}
                        {/* 1-0-0 */}
                      </Box>
                      <Box width="35%">
                        {medicine.beforefood === 1 &&
                          medicine.afterfood === 1 && <>Before & After Food</>}
                        {medicine.beforefood === 1 &&
                          (medicine.afterfood === 0 ||
                            medicine.afterfood === null) && <>Before Food</>}
                        {(medicine.beforefood === 0 ||
                          medicine.beforefood === null) &&
                          medicine.afterfood === 1 && <>After Food</>}{" "}
                        {(medicine.beforefood === 1 ||
                          medicine.afterfood === 1) &&
                          medicine.frequency &&
                          "-"}
                        {medicine.frequency &&
                          `${medicine.frequency} x per day`}
                      </Box>

                      <Box>
                        {/* Banner */}
                        <Box
                          bg={getBannerStyles(medicine.from).bg}
                          color={getBannerStyles(medicine.from).color}
                          h="24px" // Fixed height
                          p="0 4px" // Adjust padding if needed
                          borderRadius="md"
                          mb="2px"
                          fontSize="sm"
                          fontWeight="bold"
                          textAlign="center"
                          boxShadow="md"
                          display="flex"
                          alignItems="center" // Center text vertically
                          justifyContent="center" // Center text horizontally
                        >
                          {medicine.from}
                        </Box>

                        {/* Buttons */}
                        <Box display="flex" justifyContent="space-between">
                          <Box
                            as="button"
                            border="1px solid #E6E7E9"
                            borderRadius="full"
                            w="36px"
                            h="auto"
                            p="10px"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            onClick={isChatbotAllowed() ? () => fetchAiDoctorPrompts(medicine.medicinename) : null}
                            cursor={isChatbotAllowed() ? "pointer" : "not-allowed"}
                            opacity={isChatbotAllowed() ? 1 : 0.5}
                            bg={isChatbotAllowed() ? "transparent" : "gray.100"}
                            _hover={
                              isChatbotAllowed() 
                                ? { bg: "gray.50", borderColor: "gray.300" } 
                                : {}
                            }
                            title={
                              !isChatbotAllowed() 
                                ? "Please upgrade your subscription to use AI features" 
                                : "Get AI suggestions"
                            }
                          >
                            <Image 
                              w="26px" 
                              src="/assets/svgs/ai-star-outline.svg" 
                              opacity={isChatbotAllowed() ? 1 : 0.5}
                              filter={!isChatbotAllowed() ? "grayscale(100%)" : "none"}
                            />
                          </Box>
                          {/* <Box
                            as="button"
                            border="1px solid #E6E7E9"
                            borderRadius="full"
                            w="36px"
                            h="auto"
                            p="10px"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            onClick={() =>
                              fetchAiDoctorPrompts(medicine.medicinename)
                            }
                          >
                            <Image
                              w="26px"
                              src="/assets/svgs/ai-star-outline.svg"
                            />
                          </Box> */}
                          <Box
                            as="button"
                            border="1px solid #E6E7E9"
                            borderRadius="full"
                            w="36px"
                            h="auto"
                            p="10px"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            onClick={() => handleEditMedicine(medicine)}
                          >
                            <Image w="13px" src="/assets/svgs/edit-gray.svg" />
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                    {/* Reason Box */}
                    <Box
                      as="p"
                      p="2px"
                      bg="#F9FAFB"
                      w="auto"
                      borderLeft="2px solid #14C585"
                      fontSize="0.875rem"
                      fontWeight="500"
                      mt="2px"
                      ml="3rem"
                    >
                      {medicine?.reason}{" "}
                      {/* Use medicine.reason instead of response.reason */}
                    </Box>
                  </Box>

                  {editMedicine && editMedicine.id === medicine.id && (
                    <Box
                      p="20px"
                      border="1px solid gray"
                      borderRadius="10px"
                      mt="10px" // Add some margin-top to separate from the above row
                    >
                      <Stack spacing={4}>
                        <InputGroup>
                          <PrimaryInput
                            type="text"
                            variant="bothSide"
                            inputPlace="Medicine name*"
                            defaultValue={editMedicine.medicinename}
                            onChange={(e) =>
                              handleEditMedicineChange(
                                "medicinename",
                                e.target.value
                              )
                            }
                          />
                          <PrimaryInput
                            key={compositionEditKey}
                            type="text"
                            variant="bothSide"
                            inputPlace="Medicine Composition"
                            defaultValue={editMedicine.composition}
                            onChange={(e) =>
                              handleEditMedicineChange(
                                "composition",
                                e.target.value
                              )
                            }
                          />{" "}
                          <PrimaryButton
                            buttonText="Fetch"
                            verticalAlign="bottom"
                            variant="grayBtn"
                            btnStyle={{
                              w: "15%",
                              color: COLORS.PRIMARY_COLOR,
                              verticalAlign: "bottom",
                              ml: "4px",
                              mb: "0px",
                              h: "2.8rem",
                              opacity: isChatbotAllowed() ? 1 : 0.6,
                              cursor: isChatbotAllowed() ? "pointer" : "not-allowed"
                            }}
                            onClick={() => {
                                if (isChatbotAllowed()) {
                                  fetchCompositionForEdit(editMedicine.medicinename);
                                } else {
                                  showErrorToast("Please upgrade your subscription to use this feature");
                                }
                              }}
                              isDisabled={!isChatbotAllowed()}
                              title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
                              // onClick={() =>
                              //   fetchCompositionForEdit(editMedicine.medicinename)
                              // }
                              // isDisabled={false}
                          />
                        </InputGroup>
                        <RadioGroup
                          defaultValue={editMedicine.medicinetype}
                          onChange={(value) => {
                            handleEditMedicineChange("medicinetype", value);

                            if (value === "Syrup") {
                              handleEditMedicineChange("dosageunit", "ml");
                            } else if (value === "Tablet") {
                              handleEditMedicineChange("dosageunit", "mg");
                            }
                          }}
                        >
                          <Stack direction="row" gap="20px">
                            <Radio value="Tablet">Tablet</Radio>
                            <Radio value="Syrup">Syrup</Radio>
                          </Stack>
                        </RadioGroup>
                        <Divider />
                        <Box>
                          <Box display="flex" flexDir="row">
                            <MiniDropdownInput
                              variant="bothSide"
                              options={[
                                { label: "mg", value: "mg" },
                                { label: "ml", value: "ml" },
                              ]}
                              placeholderProp="Strength"
                              defaultValue={editMedicine.dosage}
                              defaultOptionProp={editMedicine.dosageunit}
                              onSelect={(value) =>
                                handleEditMedicineChange(
                                  "dosageunit",
                                  value.label
                                )
                              }
                              handleInputChange={(event) =>
                                handleEditMedicineChange(
                                  "dosage",
                                  event.target.value
                                )
                              }
                              maxLength="6"
                            />
                            <DropdownInput
                              variant="bothSide"
                              dropDownPlace="Consumption Quantity per day"
                              options={["0.5", "1", "2", "3", "4"]}
                              onClick={(value) =>
                                handleEditMedicineChange("frequency", value)
                              }
                              defaultOption={editMedicine.frequency}
                            />
                          </Box>
                          <Box display="flex" flexDir="row">
                            <DatePicker
                              // disableFutureDates={true}
                              // for default date format it in correct order
                              defaultDate={moment(
                                editMedicine.medicationstartdate,
                                ["YYYY-MM-DD", "DD-MM-YYYY"]
                              ).format("DD-MM-YYYY")}
                              minDate={editMedicine.medicationstartdate}
                              onDateChange={(selectedDateValue) =>
                                handleEditMedicineChange(
                                  "medicationstartdate",
                                  moment(selectedDateValue).format("YYYY-MM-DD")
                                )
                              }
                              placeholderProp={"Start Date"}
                              calendarStlye={{
                                left: "-18px",
                                right: "unset",
                              }}
                            />
                            <DatePicker
                              // defaultDate={editMedicine.medicationenddate}
                              defaultDate={moment(
                                editMedicine.medicationenddate,
                                ["YYYY-MM-DD", "DD-MM-YYYY"]
                              ).format("DD-MM-YYYY")}
                              minDate={editMedicine.medicationstartdate}
                              onDateChange={(selectedDateValue) =>
                                handleEditMedicineChange(
                                  "medicationenddate",
                                  moment(selectedDateValue).format("YYYY-MM-DD")
                                )
                              }
                              placeholderProp={"End Date"}
                              calendarStlye={{
                                transform: "scale(0.9)",
                                right: "-22px",
                                top: "30px",
                              }}
                            />
                          </Box>

                          <CheckboxGroup colorScheme="green">
                            <Stack spacing={2} pt="20px" direction="row">
                              <Checkbox
                                isChecked={editMedicine.morning === 1}
                                onChange={() =>
                                  handleEditMedicineChange(
                                    "morning",
                                    editMedicine.morning === 1 ? 0 : 1
                                  )
                                }
                              >
                                Morning
                              </Checkbox>
                              <Checkbox
                                isChecked={editMedicine.evening === 1}
                                onChange={() =>
                                  handleEditMedicineChange(
                                    "evening",
                                    editMedicine.evening === 1 ? 0 : 1
                                  )
                                }
                              >
                                Evening
                              </Checkbox>
                              <Checkbox
                                isChecked={editMedicine.night === 1}
                                onChange={() =>
                                  handleEditMedicineChange(
                                    "night",
                                    editMedicine.night === 1 ? 0 : 1
                                  )
                                }
                              >
                                Night
                              </Checkbox>
                              <Spacer />{" "}
                              {/* Add a spacer to push the next checkboxes to the right */}
                              <Checkbox
                                isChecked={editMedicine.beforefood === 1}
                                onChange={() =>
                                  handleEditMedicineChange(
                                    "beforefood",
                                    editMedicine.beforefood === 1 ? 0 : 1
                                  )
                                }
                              >
                                Before Food
                              </Checkbox>
                              <Checkbox
                                isChecked={editMedicine.afterfood === 1}
                                onChange={() =>
                                  handleEditMedicineChange(
                                    "afterfood",
                                    editMedicine.afterfood === 1 ? 0 : 1
                                  )
                                }
                              >
                                After Food
                              </Checkbox>
                            </Stack>
                          </CheckboxGroup>
                        </Box>
                        <Divider />
                        <Box
                          display="flex"
                          justifyContent="flex-end"
                          gap="10px"
                        >
                          {/* <Button onClick={() => setEditMedicine(null)}>
                            Cancel
                          </Button> */}
                          <PrimaryButton
                            buttonText="Cancel"
                            variant="grayBtn"
                            btnStyle={{
                              w: "15%",
                              color: COLORS.PRIMARY_COLOR,
                              h: "2.5rem",
                            }}
                            onClick={() => setEditMedicine(null)}
                            isDisabled={false}
                          />
                          {/* <Button
                            colorScheme="blue"
                            onClick={handleSaveEditMedicine}
                          >
                            Save
                          </Button> */}
                          <PrimaryButton
                            buttonText="Save"
                            onClick={handleSaveEditMedicine}
                            isDisabled={false}
                            btnStyle={{
                              w: "25%",
                              //   color: COLORS.PRIMARY_COLOR,
                              h: "2.5rem",
                            }}
                          />
                        </Box>
                      </Stack>
                    </Box>
                  )}
                </Box>
              ))}

              <Flex wrap="wrap" justify="space-between">
                {combinedOrderAIResponses &&
                  combinedOrderAIResponses.map((response, index) => (
                    <Box
                      key={index}
                      borderWidth="1px"
                      border="1px solid gray"
                      borderRadius="10px"
                      overflow="hidden"
                      h={"auto"}
                      mt="10px"
                      p={"10px"}
                      // mb={"10px"}
                      display="flex"
                      width="calc(50% - 8px)" // Ensure two boxes in a row with space between
                      onClick={() =>
                        handleRecommendedOrdersCheckboxChange(index)
                      }
                      alignItems="center"
                    >
                      <Checkbox
                        isChecked={selectedOrderAiResponses.includes(index)}
                        onChange={() =>
                          handleRecommendedOrdersCheckboxChange(index)
                        }
                        mr={4}
                        alignSelf="center" // Vertically center the checkbox
                      ></Checkbox>
                      <Box
                        // borderBottom="1px solid #E6E7E9"
                        // py="0.875rem"
                        display="flex"
                        flexDir="column"
                        w={"100%"}
                        gap="0.5rem"
                      >
                        {/* <Text fontSize="16px" fontWeight="600">
                          {response.type}: {response.subtype}
                        </Text> */}
                        {`${response.category
                          .charAt(0)
                          .toUpperCase()}${response.category.slice(1)}${
                          ["labs", "imaging"].includes(response.category)
                            ? " Test"
                            : ""
                        }: ${response.name}`}
                        <Box
                          as="p"
                          p="2px"
                          bg="#F9FAFB"
                          w={"100%"}
                          borderLeft="2px solid #14C585"
                          fontSize="0.875rem"
                          fontWeight="500"
                        >
                          {response.reason}
                          {/* {`${response.category
                            .charAt(0)
                            .toUpperCase()}${response.category.slice(1)}${
                            ["labs", "imaging"].includes(response.category)
                              ? " Test"
                              : ""
                          }: ${response.type}, ${response.subtype}`} */}
                        </Box>
                      </Box>
                    </Box>
                  ))}
              </Flex>

              {/* {recommendMedicinesAiResponse.map((response, index) => (
                <Box
                  key={index}
                  borderWidth="1px"
                  borderRadius="lg"
                  overflow="hidden"
                  p={4}
                  mb={4}
                  display="flex"
                  // as="button"
                  onClick={() =>
                    handleRecommendedMedicinesCheckboxChange(index)
                  }
                  alignItems="center"
                >
                  <Checkbox
                    isChecked={selectedRecommendedMedicinesAiResponses.includes(
                      index
                    )}
                    onChange={() =>
                      handleRecommendedMedicinesCheckboxChange(index)
                    }
                    mr={4}
                    alignSelf="center" // Vertically center the checkbox
                  ></Checkbox>
                  <Box
                    key={index}
                    borderBottom="1px solid #E6E7E9"
                    py="0.875rem"
                    display="flex"
                    flexDir="column"
                    gap="0.5rem"
                  >
                    <Text fontSize="16px" fontWeight="600">
                      {response.name}
                    </Text>
                    <Box
                      as="p"
                      p="0.5rem"
                      bg="#F9FAFB"
                      borderLeft="2px solid #14C585"
                      fontSize="0.875rem"
                      fontWeight="500"
                    >
                      Composition: {response.composition}
                    </Box>
                  </Box>
                </Box>
              ))} */}

              {useGPUChatbot ? (
                <AIFeedbackFooter
                  disclaimer={
                    "AIRA strives to be as accurate as possible, but occasional errors may occur. Please verify its responses to ensure the information meets your needs. Your discretion will ensure the best experience."
                  }
                  doctorId={doctorId}
                  patientId={patientId}
                  appointmentId={appointmentId}
                  aiInput={aiInputForFeedback}
                  aiOutput={aiOutputForFeedback}
                  featureType={"Assist Orders"}
                />
              ) : (
                <AICPUFeedbackFooter
                  disclaimer={
                    "AIRA strives to be as accurate as possible, but occasional errors may occur. Please verify its responses to ensure the information meets your needs. Your discretion will ensure the best experience."
                  }
                  doctorId={doctorId}
                  patientId={patientId}
                  appointmentId={appointmentId}
                  aiInput={aiInputForFeedback}
                  aiOutput={aiOutputForFeedback}
                  featureType={"Assist Orders"}
                />
              )}
            </>
          }
          modalFooterBtn={
            <>
              <PrimaryButton
                variant="deleteBtn"
                buttonText="Discard"
                btnStyle={{
                  w: "48%",
                  h: "2.5rem",
                }}
                onClick={() => {
                  setEditMedicine(null);
                  aiRecommendMedicineRef.current.closeModal();
                }}
              />

              <Spacer />

              <PrimaryButton
                buttonText="Save selected items"
                variant="grayBtn"
                btnStyle={{
                  w: "48%",
                  color: COLORS.PRIMARY_COLOR,
                  h: "2.5rem",
                }}
                isDisabled={
                  !(
                    selectedRecommendedMedicinesAiResponses.length > 0 ||
                    selectedOrderAiResponses.length > 0
                  )
                }
                onClick={() => {
                  setEditMedicine(null);
                  saveSelectedRecommendedMedicinesToOrder();
                  aiRecommendMedicineRef.current.closeModal();
                }}
              />
            </>
          }
        />

        {/* DynamicModal for No AI response */}
        {/* <DynamicModal
          ref={noAiResponseModal}
          modalHeader={`Aira - AI: Recommended Prescription`}
          modalBody={
            <>
              <Text fontSize="14px" fontWeight="600">
                Insufficient data is available to draw inferences. Please ensure
                that relevant notes are provided.
              </Text>
            </>
          }
          modalFooterBtn={
            <>
              <PrimaryButton
                buttonText="Close"
                variant="grayBtn"
                btnStyle={{
                  w: "100%",
                  color: COLORS.PRIMARY_COLOR,
                  h: "2.5rem",
                }}
                onClick={() => {
                  noAiResponseModal.current.closeModal();
                }}
              />
            </>
          }
        /> */}

        <DynamicModal
          ref={noAiResponseModal}
          modalHeader={`Aira - AI: Recommended Prescription`}
          modalBody={renderModalContent(doctorNotes)}
          modalFooterBtn={
            <>
              <PrimaryButton
                buttonText="Close"
                variant="grayBtn"
                btnStyle={{
                  w: "100%",
                  color: COLORS.PRIMARY_COLOR,
                  h: "2.5rem",
                }}
                onClick={() => {
                  noAiResponseModal.current.closeModal();
                }}
              />
            </>
          }
        />

        <ModalRight
                  ref={addCondition}
                  header="Add vaccine"
                  body={
                    <>
                      <SearchBar
                        passInputPlace="Search condition"
                        onChange={(e) => setSearchValue(e.target.value)}
                      />
                      <RadioGroup>
                        <Stack direction="column" gap="0">
                          <Box display="flex" justifyContent="end" w="100%">
                            <Stack direction="column" gap="0" w="100%">
                              {conditionsList && conditionsList.length > 0 ? (
                                conditionsList.some((category) =>
                                  category.data.some((condition) =>
                                    condition.condition
                                      .toLowerCase()
                                      .includes(searchValue.toLowerCase())
                                  )
                                ) ? (
                                  conditionsList.map((category) => (
                                    <React.Fragment key={category.category_id}>
                                      {category.data
                                        .filter((condition) =>
                                          condition.condition
                                            .toLowerCase()
                                            .includes(searchValue.toLowerCase())
                                        )
                                        .map((condition) => (
                                          <label key={condition.condition_cd}>
                                            <Box
                                              display="flex"
                                              justifyContent="space-between"
                                              borderBottom="1px solid #e2e8f0"
                                              p="15px"
                                              pl="5px"
                                              minH="50px"
                                              width="100%"
                                              sx={{
                                                _hover: {
                                                  border: "2px solid #384052",
                                                  borderRadius: "10px",
                                                },
                                              }}
                                            >
                                              <Box
                                                key={condition.condition_cd}
                                                display="flex"
                                                alignItems="center"
                                              >
                                                <Text
                                                  fontSize="16px"
                                                  lineHeight="normal"
                                                  fontWeight="600"
                                                >
                                                  {/* {condition.condition} */}
                                                  {condition.condition}{condition.age_range ? ` (${condition.age_range})` : ""}
                                                </Text>
                                              </Box>
                                              <Box display="flex" justifyContent="end">
                                                <Checkbox
                                                  colorScheme="green"
                                                  sx={{
                                                    ".chakra-checkbox__control": {
                                                      width: "20px",
                                                      height: "20px",
                                                      borderRadius: "5px",
                                                    },
                                                  }}
                                                  onChange={() =>
                                                    handleCheckboxChangeVaccine(condition)
                                                  }
                                                  isChecked={selectedConditions.some(
                                                    (item) =>
                                                      item.condition_cd ===
                                                      condition.condition_cd
                                                  )}
                                                ></Checkbox>
                                              </Box>
                                            </Box>
                                          </label>
                                        ))}
                                    </React.Fragment>
                                  ))
                                ) : (
                                  <Box
                                    p="15px"
                                    fontSize="16px"
                                    fontWeight="600"
                                    textAlign="center"
                                  >
                                    No matching vaccinations found!
                                  </Box>
                                )
                              ) : (
                                <p>Loading...</p>
                              )}
                              <Divider />
                              <br />
                              <Heading
                                as="h2"
                                fontSize="12px"
                                pl="5px"
                                textTransform="uppercase"
                                fontWeight="600"
                                my="10px"
                              >
                                Other Vaccination
                              </Heading>
                              <PrimaryInput
                                inputPlace="Vaccination"
                                variant="bothSide"
                                onChange={handleCondition}
                                inputValue={typedCondition}
                              />
                              <br />
                            </Stack>
                          </Box>
                        </Stack>
                      </RadioGroup>
        
                      <ModalRight
                        ref={addCondition2}
                        header="Add Vaccination"
                        body={
                          <>
                            <Box display="flex" flexDir="column" gap="20px">
                              {selectedConditions.map((condition, index) => (
                                <Box key={index}>
                                  <Text fontSize="16px" py="10px" fontWeight="600">
                                    {condition.condition}
                                  </Text>
        
                                  {/* <DatePicker
                                    disableFutureDates={true}
                                    //minDate={null}
                                    maxDate={maxDateState}
                                    onDateChange={(selectedDateValue) =>
                                      handleDateChange(
                                        condition.condition_cd,
                                        selectedDateValue
                                      )
                                    }
                                    placeholderProp="Admin Date*"
                                  /> */}
        
                                  <DatePickerQuick
                                    disableFutureDates={true}
                                    // patientDOB={PatientDOB}
                                    maxDate={maxDateState}
                                    CUSTOM_DISABLE={true}
                                    placeholderProp="Select Admin Date*"
                                    // defaultDate={todaysDate}
                                    onDateChange={(selectedDateValue) =>
                                      handleDateChange(
                                        condition.condition_cd,
                                        selectedDateValue
                                      )
                                    }
                                    calendarStlye={{
                                      transform: "scale(0.9)",
                                      right: "-22px",
                                      top: "30px",
                                    }}
                                  />
        
                                  {/* <DatePicker
                                    disablePastDates={true}
                                    //minDate={minDateState}
                                    onDateChange={(selectedDateValue) =>
                                      handleDueDateChange(
                                        condition.condition_cd,
                                        selectedDateValue
                                      )
                                    }
                                    placeholderProp="Due Date"
                                    minDate={new Date().toISOString()}
                                  /> */}
        
                                  <DatePickerQuick
                                    disablePastDates={true}
                                    // patientDOB={PatientDOB}
                                    CUSTOM_DISABLE={true}
                                    placeholderProp="Select Due Date"
                                    minDate={new Date().toISOString()}
                                    // defaultDate={todaysDate}
                                    onDateChange={(selectedDateValue) =>
                                      handleDueDateChange(
                                        condition.condition_cd,
                                        selectedDateValue
                                      )
                                    }
                                    calendarStlye={{
                                      transform: "scale(0.9)",
                                      right: "-22px",
                                      top: "30px",
                                    }}
                                  />
        
                                  
                          {/* Upload document JSX start ---------- */}
        {/* {documentURLs?.map((document, index) => {
                                if (document.condition_cd == condition.condition_cd || (document.condition_cd == null && condition.condition_cd == null)) {
                                  if (!indexMap[document.condition_cd]) {
                                    indexMap[document.condition_cd] = 1;
                                  }
                                  const docIndex = indexMap[document.condition_cd];
                                  indexMap[document.condition_cd]++; // Increment index for next document with same condition_cd
        
                                  return (
                                    <Box key={index} mb="2" mt="2">
                                      <Button
                                        as="a"
                                        rel="noopener noreferrer"
                                        w="100%"
                                        h="48px"
                                        borderRadius="10px"
                                        border="1px solid #E6E7E9"
                                        display="flex"
                                        justifyContent="space-between"
                                        bg="white"
                                        color="#1C4EC5"
                                        sx={{ _hover: { bg: "none" } }}
                                        style={{
                                          overflow: "hidden",
                                          whiteSpace: "nowrap",
                                          textOverflow: "ellipsis",
                                          fontSize: "12px",
                                        }}
                                      >
                                        Document {docIndex}
                                        <Box as="span" onClick={() => handleDelete(index)}>
                                          <Image src="/assets/imgs/delete.png" />
                                        </Box>
                                      </Button>
                                    </Box>
                                  );
                                }
                              })}
                              <Box 
                              onClick={() => addVaccineUploadDocument(condition)} 
                              as="button" display="flex" alignItems="center" gap="10px" mt="5px" fontSize="14px" fontWeight="600" color="#1C4EC5" textAlign="left">
                                <Image w="11px" src="/assets/imgs/add-blue.png" />
                                Add Document
                              </Box>
        
                              <input
                                type='file'
                                id='file-upload'
                                onChange={(e) => handleVaccineUpload(e)}
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                              /> */}
        
                              
                              {/* Upload document JSX End ---------- |||||| */}
                        
                                </Box>
                              ))}
                            </Box>
                          </>
                        }
                        footerActions={
                          <>
                            <Box w="100%" display="flex" flexDirection="row" gap="15px">
                              <PrimaryButton
                                buttonText="Add Vaccine"
                                // isDisabled={actionAccessPatients?.create ? false : true}
                                isDisabled={false || !actionAccessMain(22)?.create}
                                onClick={AddMedicalConditionsCall}
                              />
                            </Box>
                          </>
                        }
                      />
                    </>
                  }
                  footerActions={
                    <>
                      <Box w="100%" display="flex" flexDirection="row" gap="15px">
                        <PrimaryButton
                          buttonText="Continue"
                          isDisabled={false}
                          onClick={AddMedicalConditions}
                        />
                      </Box>
                    </>
                  }
                />
      </Box>
    );
  }
);

export default DoctorNotesOrders;
